/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.cn = (function() {

    /**
     * Namespace cn.
     * @exports cn
     * @namespace
     */
    var cn = {};

    cn.beepower = (function() {

        /**
         * Namespace beepower.
         * @memberof cn
         * @namespace
         */
        var beepower = {};

        beepower.domain = (function() {

            /**
             * Namespace domain.
             * @memberof cn.beepower
             * @namespace
             */
            var domain = {};

            domain.message = (function() {

                /**
                 * Namespace message.
                 * @memberof cn.beepower.domain
                 * @namespace
                 */
                var message = {};

                message.Payload = (function() {

                    /**
                     * Properties of a Payload.
                     * @memberof cn.beepower.domain.message
                     * @interface IPayload
                     * @property {Uint8Array|null} [value] Payload value
                     * @property {string|null} [payloadType] Payload payloadType
                     * @property {string|null} [url] Payload url
                     * @property {boolean|null} [testFlag] Payload testFlag
                     * @property {string|null} [traceTag] Payload traceTag
                     * @property {string|null} [clientId] Payload clientId
                     * @property {number|Long|null} [messageId] Payload messageId
                     */

                    /**
                     * Constructs a new Payload.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a Payload.
                     * @implements IPayload
                     * @constructor
                     * @param {cn.beepower.domain.message.IPayload=} [properties] Properties to set
                     */
                    function Payload(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Payload value.
                     * @member {Uint8Array} value
                     * @memberof cn.beepower.domain.message.Payload
                     * @instance
                     */
                    Payload.prototype.value = $util.newBuffer([]);

                    /**
                     * Payload payloadType.
                     * @member {string} payloadType
                     * @memberof cn.beepower.domain.message.Payload
                     * @instance
                     */
                    Payload.prototype.payloadType = "";

                    /**
                     * Payload url.
                     * @member {string} url
                     * @memberof cn.beepower.domain.message.Payload
                     * @instance
                     */
                    Payload.prototype.url = "";

                    /**
                     * Payload testFlag.
                     * @member {boolean} testFlag
                     * @memberof cn.beepower.domain.message.Payload
                     * @instance
                     */
                    Payload.prototype.testFlag = false;

                    /**
                     * Payload traceTag.
                     * @member {string} traceTag
                     * @memberof cn.beepower.domain.message.Payload
                     * @instance
                     */
                    Payload.prototype.traceTag = "";

                    /**
                     * Payload clientId.
                     * @member {string} clientId
                     * @memberof cn.beepower.domain.message.Payload
                     * @instance
                     */
                    Payload.prototype.clientId = "";

                    /**
                     * Payload messageId.
                     * @member {number|Long} messageId
                     * @memberof cn.beepower.domain.message.Payload
                     * @instance
                     */
                    Payload.prototype.messageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new Payload instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Payload
                     * @static
                     * @param {cn.beepower.domain.message.IPayload=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Payload} Payload instance
                     */
                    Payload.create = function create(properties) {
                        return new Payload(properties);
                    };

                    /**
                     * Encodes the specified Payload message. Does not implicitly {@link cn.beepower.domain.message.Payload.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Payload
                     * @static
                     * @param {cn.beepower.domain.message.IPayload} message Payload message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Payload.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
                        if (message.payloadType != null && Object.hasOwnProperty.call(message, "payloadType"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.payloadType);
                        if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.url);
                        if (message.testFlag != null && Object.hasOwnProperty.call(message, "testFlag"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.testFlag);
                        if (message.traceTag != null && Object.hasOwnProperty.call(message, "traceTag"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.traceTag);
                        if (message.clientId != null && Object.hasOwnProperty.call(message, "clientId"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.clientId);
                        if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int64(message.messageId);
                        return writer;
                    };

                    /**
                     * Encodes the specified Payload message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Payload.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Payload
                     * @static
                     * @param {cn.beepower.domain.message.IPayload} message Payload message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Payload.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Payload message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Payload
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Payload} Payload
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Payload.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Payload();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.value = reader.bytes();
                                break;
                            case 2:
                                message.payloadType = reader.string();
                                break;
                            case 3:
                                message.url = reader.string();
                                break;
                            case 10:
                                message.testFlag = reader.bool();
                                break;
                            case 13:
                                message.traceTag = reader.string();
                                break;
                            case 14:
                                message.clientId = reader.string();
                                break;
                            case 15:
                                message.messageId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Payload message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Payload
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Payload} Payload
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Payload.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Payload message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Payload
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Payload.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                                return "value: buffer expected";
                        if (message.payloadType != null && message.hasOwnProperty("payloadType"))
                            if (!$util.isString(message.payloadType))
                                return "payloadType: string expected";
                        if (message.url != null && message.hasOwnProperty("url"))
                            if (!$util.isString(message.url))
                                return "url: string expected";
                        if (message.testFlag != null && message.hasOwnProperty("testFlag"))
                            if (typeof message.testFlag !== "boolean")
                                return "testFlag: boolean expected";
                        if (message.traceTag != null && message.hasOwnProperty("traceTag"))
                            if (!$util.isString(message.traceTag))
                                return "traceTag: string expected";
                        if (message.clientId != null && message.hasOwnProperty("clientId"))
                            if (!$util.isString(message.clientId))
                                return "clientId: string expected";
                        if (message.messageId != null && message.hasOwnProperty("messageId"))
                            if (!$util.isInteger(message.messageId) && !(message.messageId && $util.isInteger(message.messageId.low) && $util.isInteger(message.messageId.high)))
                                return "messageId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a Payload message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Payload
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Payload} Payload
                     */
                    Payload.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Payload)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Payload();
                        if (object.value != null)
                            if (typeof object.value === "string")
                                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                            else if (object.value.length)
                                message.value = object.value;
                        if (object.payloadType != null)
                            message.payloadType = String(object.payloadType);
                        if (object.url != null)
                            message.url = String(object.url);
                        if (object.testFlag != null)
                            message.testFlag = Boolean(object.testFlag);
                        if (object.traceTag != null)
                            message.traceTag = String(object.traceTag);
                        if (object.clientId != null)
                            message.clientId = String(object.clientId);
                        if (object.messageId != null)
                            if ($util.Long)
                                (message.messageId = $util.Long.fromValue(object.messageId)).unsigned = false;
                            else if (typeof object.messageId === "string")
                                message.messageId = parseInt(object.messageId, 10);
                            else if (typeof object.messageId === "number")
                                message.messageId = object.messageId;
                            else if (typeof object.messageId === "object")
                                message.messageId = new $util.LongBits(object.messageId.low >>> 0, object.messageId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a Payload message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Payload
                     * @static
                     * @param {cn.beepower.domain.message.Payload} message Payload
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Payload.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if (options.bytes === String)
                                object.value = "";
                            else {
                                object.value = [];
                                if (options.bytes !== Array)
                                    object.value = $util.newBuffer(object.value);
                            }
                            object.payloadType = "";
                            object.url = "";
                            object.testFlag = false;
                            object.traceTag = "";
                            object.clientId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.messageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.messageId = options.longs === String ? "0" : 0;
                        }
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                        if (message.payloadType != null && message.hasOwnProperty("payloadType"))
                            object.payloadType = message.payloadType;
                        if (message.url != null && message.hasOwnProperty("url"))
                            object.url = message.url;
                        if (message.testFlag != null && message.hasOwnProperty("testFlag"))
                            object.testFlag = message.testFlag;
                        if (message.traceTag != null && message.hasOwnProperty("traceTag"))
                            object.traceTag = message.traceTag;
                        if (message.clientId != null && message.hasOwnProperty("clientId"))
                            object.clientId = message.clientId;
                        if (message.messageId != null && message.hasOwnProperty("messageId"))
                            if (typeof message.messageId === "number")
                                object.messageId = options.longs === String ? String(message.messageId) : message.messageId;
                            else
                                object.messageId = options.longs === String ? $util.Long.prototype.toString.call(message.messageId) : options.longs === Number ? new $util.LongBits(message.messageId.low >>> 0, message.messageId.high >>> 0).toNumber() : message.messageId;
                        return object;
                    };

                    /**
                     * Converts this Payload to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Payload
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Payload.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Payload;
                })();

                message.BeeMessage = (function() {

                    /**
                     * Properties of a BeeMessage.
                     * @memberof cn.beepower.domain.message
                     * @interface IBeeMessage
                     * @property {string|null} [topic] BeeMessage topic
                     * @property {cn.beepower.domain.message.IPayload|null} [payload] BeeMessage payload
                     * @property {number|null} [qos] BeeMessage qos
                     * @property {boolean|null} [retainFlag] BeeMessage retainFlag
                     */

                    /**
                     * Constructs a new BeeMessage.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a BeeMessage.
                     * @implements IBeeMessage
                     * @constructor
                     * @param {cn.beepower.domain.message.IBeeMessage=} [properties] Properties to set
                     */
                    function BeeMessage(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BeeMessage topic.
                     * @member {string} topic
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @instance
                     */
                    BeeMessage.prototype.topic = "";

                    /**
                     * BeeMessage payload.
                     * @member {cn.beepower.domain.message.IPayload|null|undefined} payload
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @instance
                     */
                    BeeMessage.prototype.payload = null;

                    /**
                     * BeeMessage qos.
                     * @member {number} qos
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @instance
                     */
                    BeeMessage.prototype.qos = 0;

                    /**
                     * BeeMessage retainFlag.
                     * @member {boolean} retainFlag
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @instance
                     */
                    BeeMessage.prototype.retainFlag = false;

                    /**
                     * Creates a new BeeMessage instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @static
                     * @param {cn.beepower.domain.message.IBeeMessage=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.BeeMessage} BeeMessage instance
                     */
                    BeeMessage.create = function create(properties) {
                        return new BeeMessage(properties);
                    };

                    /**
                     * Encodes the specified BeeMessage message. Does not implicitly {@link cn.beepower.domain.message.BeeMessage.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @static
                     * @param {cn.beepower.domain.message.IBeeMessage} message BeeMessage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BeeMessage.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.topic != null && Object.hasOwnProperty.call(message, "topic"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.topic);
                        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                            $root.cn.beepower.domain.message.Payload.encode(message.payload, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.qos != null && Object.hasOwnProperty.call(message, "qos"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.qos);
                        if (message.retainFlag != null && Object.hasOwnProperty.call(message, "retainFlag"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.retainFlag);
                        return writer;
                    };

                    /**
                     * Encodes the specified BeeMessage message, length delimited. Does not implicitly {@link cn.beepower.domain.message.BeeMessage.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @static
                     * @param {cn.beepower.domain.message.IBeeMessage} message BeeMessage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BeeMessage.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BeeMessage message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.BeeMessage} BeeMessage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BeeMessage.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.BeeMessage();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.topic = reader.string();
                                break;
                            case 2:
                                message.payload = $root.cn.beepower.domain.message.Payload.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.qos = reader.int32();
                                break;
                            case 7:
                                message.retainFlag = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BeeMessage message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.BeeMessage} BeeMessage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BeeMessage.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BeeMessage message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BeeMessage.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.topic != null && message.hasOwnProperty("topic"))
                            if (!$util.isString(message.topic))
                                return "topic: string expected";
                        if (message.payload != null && message.hasOwnProperty("payload")) {
                            var error = $root.cn.beepower.domain.message.Payload.verify(message.payload);
                            if (error)
                                return "payload." + error;
                        }
                        if (message.qos != null && message.hasOwnProperty("qos"))
                            if (!$util.isInteger(message.qos))
                                return "qos: integer expected";
                        if (message.retainFlag != null && message.hasOwnProperty("retainFlag"))
                            if (typeof message.retainFlag !== "boolean")
                                return "retainFlag: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a BeeMessage message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.BeeMessage} BeeMessage
                     */
                    BeeMessage.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.BeeMessage)
                            return object;
                        var message = new $root.cn.beepower.domain.message.BeeMessage();
                        if (object.topic != null)
                            message.topic = String(object.topic);
                        if (object.payload != null) {
                            if (typeof object.payload !== "object")
                                throw TypeError(".cn.beepower.domain.message.BeeMessage.payload: object expected");
                            message.payload = $root.cn.beepower.domain.message.Payload.fromObject(object.payload);
                        }
                        if (object.qos != null)
                            message.qos = object.qos | 0;
                        if (object.retainFlag != null)
                            message.retainFlag = Boolean(object.retainFlag);
                        return message;
                    };

                    /**
                     * Creates a plain object from a BeeMessage message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @static
                     * @param {cn.beepower.domain.message.BeeMessage} message BeeMessage
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BeeMessage.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.topic = "";
                            object.payload = null;
                            object.qos = 0;
                            object.retainFlag = false;
                        }
                        if (message.topic != null && message.hasOwnProperty("topic"))
                            object.topic = message.topic;
                        if (message.payload != null && message.hasOwnProperty("payload"))
                            object.payload = $root.cn.beepower.domain.message.Payload.toObject(message.payload, options);
                        if (message.qos != null && message.hasOwnProperty("qos"))
                            object.qos = message.qos;
                        if (message.retainFlag != null && message.hasOwnProperty("retainFlag"))
                            object.retainFlag = message.retainFlag;
                        return object;
                    };

                    /**
                     * Converts this BeeMessage to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.BeeMessage
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BeeMessage.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return BeeMessage;
                })();

                /**
                 * ResultType enum.
                 * @name cn.beepower.domain.message.ResultType
                 * @enum {number}
                 * @property {number} INVALID_PARAMETERS=0 INVALID_PARAMETERS value
                 * @property {number} ILLEGAL_STATE=1 ILLEGAL_STATE value
                 * @property {number} OPERATION_REJECTED=2 OPERATION_REJECTED value
                 * @property {number} OPERATION_FAIL=3 OPERATION_FAIL value
                 * @property {number} OPERATION_EXCEPTION=4 OPERATION_EXCEPTION value
                 * @property {number} TIME_OUT=5 TIME_OUT value
                 * @property {number} PASS=9 PASS value
                 * @property {number} OK=10 OK value
                 */
                message.ResultType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "INVALID_PARAMETERS"] = 0;
                    values[valuesById[1] = "ILLEGAL_STATE"] = 1;
                    values[valuesById[2] = "OPERATION_REJECTED"] = 2;
                    values[valuesById[3] = "OPERATION_FAIL"] = 3;
                    values[valuesById[4] = "OPERATION_EXCEPTION"] = 4;
                    values[valuesById[5] = "TIME_OUT"] = 5;
                    values[valuesById[9] = "PASS"] = 9;
                    values[valuesById[10] = "OK"] = 10;
                    return values;
                })();

                message.Result = (function() {

                    /**
                     * Properties of a Result.
                     * @memberof cn.beepower.domain.message
                     * @interface IResult
                     * @property {cn.beepower.domain.message.ResultType|null} [type] Result type
                     * @property {string|null} [message] Result message
                     * @property {Uint8Array|null} [value] Result value
                     * @property {string|null} [valueType] Result valueType
                     */

                    /**
                     * Constructs a new Result.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a Result.
                     * @implements IResult
                     * @constructor
                     * @param {cn.beepower.domain.message.IResult=} [properties] Properties to set
                     */
                    function Result(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Result type.
                     * @member {cn.beepower.domain.message.ResultType} type
                     * @memberof cn.beepower.domain.message.Result
                     * @instance
                     */
                    Result.prototype.type = 0;

                    /**
                     * Result message.
                     * @member {string} message
                     * @memberof cn.beepower.domain.message.Result
                     * @instance
                     */
                    Result.prototype.message = "";

                    /**
                     * Result value.
                     * @member {Uint8Array} value
                     * @memberof cn.beepower.domain.message.Result
                     * @instance
                     */
                    Result.prototype.value = $util.newBuffer([]);

                    /**
                     * Result valueType.
                     * @member {string} valueType
                     * @memberof cn.beepower.domain.message.Result
                     * @instance
                     */
                    Result.prototype.valueType = "";

                    /**
                     * Creates a new Result instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Result
                     * @static
                     * @param {cn.beepower.domain.message.IResult=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Result} Result instance
                     */
                    Result.create = function create(properties) {
                        return new Result(properties);
                    };

                    /**
                     * Encodes the specified Result message. Does not implicitly {@link cn.beepower.domain.message.Result.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Result
                     * @static
                     * @param {cn.beepower.domain.message.IResult} message Result message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Result.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.value);
                        if (message.valueType != null && Object.hasOwnProperty.call(message, "valueType"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.valueType);
                        return writer;
                    };

                    /**
                     * Encodes the specified Result message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Result.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Result
                     * @static
                     * @param {cn.beepower.domain.message.IResult} message Result message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Result.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Result message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Result
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Result} Result
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Result.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Result();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.message = reader.string();
                                break;
                            case 10:
                                message.value = reader.bytes();
                                break;
                            case 11:
                                message.valueType = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Result message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Result
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Result} Result
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Result.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Result message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Result
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Result.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 9:
                            case 10:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                                return "value: buffer expected";
                        if (message.valueType != null && message.hasOwnProperty("valueType"))
                            if (!$util.isString(message.valueType))
                                return "valueType: string expected";
                        return null;
                    };

                    /**
                     * Creates a Result message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Result
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Result} Result
                     */
                    Result.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Result)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Result();
                        switch (object.type) {
                        case "INVALID_PARAMETERS":
                        case 0:
                            message.type = 0;
                            break;
                        case "ILLEGAL_STATE":
                        case 1:
                            message.type = 1;
                            break;
                        case "OPERATION_REJECTED":
                        case 2:
                            message.type = 2;
                            break;
                        case "OPERATION_FAIL":
                        case 3:
                            message.type = 3;
                            break;
                        case "OPERATION_EXCEPTION":
                        case 4:
                            message.type = 4;
                            break;
                        case "TIME_OUT":
                        case 5:
                            message.type = 5;
                            break;
                        case "PASS":
                        case 9:
                            message.type = 9;
                            break;
                        case "OK":
                        case 10:
                            message.type = 10;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        if (object.value != null)
                            if (typeof object.value === "string")
                                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                            else if (object.value.length)
                                message.value = object.value;
                        if (object.valueType != null)
                            message.valueType = String(object.valueType);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Result message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Result
                     * @static
                     * @param {cn.beepower.domain.message.Result} message Result
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Result.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "INVALID_PARAMETERS" : 0;
                            object.message = "";
                            if (options.bytes === String)
                                object.value = "";
                            else {
                                object.value = [];
                                if (options.bytes !== Array)
                                    object.value = $util.newBuffer(object.value);
                            }
                            object.valueType = "";
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.cn.beepower.domain.message.ResultType[message.type] : message.type;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                        if (message.valueType != null && message.hasOwnProperty("valueType"))
                            object.valueType = message.valueType;
                        return object;
                    };

                    /**
                     * Converts this Result to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Result
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Result.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Result;
                })();

                message.Item = (function() {

                    /**
                     * Properties of an Item.
                     * @memberof cn.beepower.domain.message
                     * @interface IItem
                     * @property {string|null} [t] Item t
                     * @property {number|null} [i] Item i
                     * @property {number|Long|null} [l] Item l
                     * @property {number|null} [f] Item f
                     * @property {number|null} [d] Item d
                     * @property {boolean|null} [b] Item b
                     * @property {string|null} [s] Item s
                     * @property {Uint8Array|null} [bs] Item bs
                     */

                    /**
                     * Constructs a new Item.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents an Item.
                     * @implements IItem
                     * @constructor
                     * @param {cn.beepower.domain.message.IItem=} [properties] Properties to set
                     */
                    function Item(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Item t.
                     * @member {string} t
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     */
                    Item.prototype.t = "";

                    /**
                     * Item i.
                     * @member {number} i
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     */
                    Item.prototype.i = 0;

                    /**
                     * Item l.
                     * @member {number|Long} l
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     */
                    Item.prototype.l = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Item f.
                     * @member {number} f
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     */
                    Item.prototype.f = 0;

                    /**
                     * Item d.
                     * @member {number} d
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     */
                    Item.prototype.d = 0;

                    /**
                     * Item b.
                     * @member {boolean} b
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     */
                    Item.prototype.b = false;

                    /**
                     * Item s.
                     * @member {string} s
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     */
                    Item.prototype.s = "";

                    /**
                     * Item bs.
                     * @member {Uint8Array} bs
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     */
                    Item.prototype.bs = $util.newBuffer([]);

                    /**
                     * Creates a new Item instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Item
                     * @static
                     * @param {cn.beepower.domain.message.IItem=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Item} Item instance
                     */
                    Item.create = function create(properties) {
                        return new Item(properties);
                    };

                    /**
                     * Encodes the specified Item message. Does not implicitly {@link cn.beepower.domain.message.Item.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Item
                     * @static
                     * @param {cn.beepower.domain.message.IItem} message Item message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Item.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.i != null && Object.hasOwnProperty.call(message, "i"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.i);
                        if (message.l != null && Object.hasOwnProperty.call(message, "l"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.l);
                        if (message.f != null && Object.hasOwnProperty.call(message, "f"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.f);
                        if (message.d != null && Object.hasOwnProperty.call(message, "d"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.d);
                        if (message.b != null && Object.hasOwnProperty.call(message, "b"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.b);
                        if (message.s != null && Object.hasOwnProperty.call(message, "s"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.s);
                        if (message.bs != null && Object.hasOwnProperty.call(message, "bs"))
                            writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.bs);
                        if (message.t != null && Object.hasOwnProperty.call(message, "t"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.t);
                        return writer;
                    };

                    /**
                     * Encodes the specified Item message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Item.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Item
                     * @static
                     * @param {cn.beepower.domain.message.IItem} message Item message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Item.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Item message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Item
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Item} Item
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Item.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Item();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 15:
                                message.t = reader.string();
                                break;
                            case 1:
                                message.i = reader.int32();
                                break;
                            case 2:
                                message.l = reader.int64();
                                break;
                            case 3:
                                message.f = reader.float();
                                break;
                            case 4:
                                message.d = reader.double();
                                break;
                            case 5:
                                message.b = reader.bool();
                                break;
                            case 6:
                                message.s = reader.string();
                                break;
                            case 7:
                                message.bs = reader.bytes();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Item message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Item
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Item} Item
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Item.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Item message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Item
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Item.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.t != null && message.hasOwnProperty("t"))
                            if (!$util.isString(message.t))
                                return "t: string expected";
                        if (message.i != null && message.hasOwnProperty("i"))
                            if (!$util.isInteger(message.i))
                                return "i: integer expected";
                        if (message.l != null && message.hasOwnProperty("l"))
                            if (!$util.isInteger(message.l) && !(message.l && $util.isInteger(message.l.low) && $util.isInteger(message.l.high)))
                                return "l: integer|Long expected";
                        if (message.f != null && message.hasOwnProperty("f"))
                            if (typeof message.f !== "number")
                                return "f: number expected";
                        if (message.d != null && message.hasOwnProperty("d"))
                            if (typeof message.d !== "number")
                                return "d: number expected";
                        if (message.b != null && message.hasOwnProperty("b"))
                            if (typeof message.b !== "boolean")
                                return "b: boolean expected";
                        if (message.s != null && message.hasOwnProperty("s"))
                            if (!$util.isString(message.s))
                                return "s: string expected";
                        if (message.bs != null && message.hasOwnProperty("bs"))
                            if (!(message.bs && typeof message.bs.length === "number" || $util.isString(message.bs)))
                                return "bs: buffer expected";
                        return null;
                    };

                    /**
                     * Creates an Item message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Item
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Item} Item
                     */
                    Item.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Item)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Item();
                        if (object.t != null)
                            message.t = String(object.t);
                        if (object.i != null)
                            message.i = object.i | 0;
                        if (object.l != null)
                            if ($util.Long)
                                (message.l = $util.Long.fromValue(object.l)).unsigned = false;
                            else if (typeof object.l === "string")
                                message.l = parseInt(object.l, 10);
                            else if (typeof object.l === "number")
                                message.l = object.l;
                            else if (typeof object.l === "object")
                                message.l = new $util.LongBits(object.l.low >>> 0, object.l.high >>> 0).toNumber();
                        if (object.f != null)
                            message.f = Number(object.f);
                        if (object.d != null)
                            message.d = Number(object.d);
                        if (object.b != null)
                            message.b = Boolean(object.b);
                        if (object.s != null)
                            message.s = String(object.s);
                        if (object.bs != null)
                            if (typeof object.bs === "string")
                                $util.base64.decode(object.bs, message.bs = $util.newBuffer($util.base64.length(object.bs)), 0);
                            else if (object.bs.length)
                                message.bs = object.bs;
                        return message;
                    };

                    /**
                     * Creates a plain object from an Item message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Item
                     * @static
                     * @param {cn.beepower.domain.message.Item} message Item
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Item.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.i = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.l = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.l = options.longs === String ? "0" : 0;
                            object.f = 0;
                            object.d = 0;
                            object.b = false;
                            object.s = "";
                            if (options.bytes === String)
                                object.bs = "";
                            else {
                                object.bs = [];
                                if (options.bytes !== Array)
                                    object.bs = $util.newBuffer(object.bs);
                            }
                            object.t = "";
                        }
                        if (message.i != null && message.hasOwnProperty("i"))
                            object.i = message.i;
                        if (message.l != null && message.hasOwnProperty("l"))
                            if (typeof message.l === "number")
                                object.l = options.longs === String ? String(message.l) : message.l;
                            else
                                object.l = options.longs === String ? $util.Long.prototype.toString.call(message.l) : options.longs === Number ? new $util.LongBits(message.l.low >>> 0, message.l.high >>> 0).toNumber() : message.l;
                        if (message.f != null && message.hasOwnProperty("f"))
                            object.f = options.json && !isFinite(message.f) ? String(message.f) : message.f;
                        if (message.d != null && message.hasOwnProperty("d"))
                            object.d = options.json && !isFinite(message.d) ? String(message.d) : message.d;
                        if (message.b != null && message.hasOwnProperty("b"))
                            object.b = message.b;
                        if (message.s != null && message.hasOwnProperty("s"))
                            object.s = message.s;
                        if (message.bs != null && message.hasOwnProperty("bs"))
                            object.bs = options.bytes === String ? $util.base64.encode(message.bs, 0, message.bs.length) : options.bytes === Array ? Array.prototype.slice.call(message.bs) : message.bs;
                        if (message.t != null && message.hasOwnProperty("t"))
                            object.t = message.t;
                        return object;
                    };

                    /**
                     * Converts this Item to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Item
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Item.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Item;
                })();

                message.Items = (function() {

                    /**
                     * Properties of an Items.
                     * @memberof cn.beepower.domain.message
                     * @interface IItems
                     * @property {string|null} [t] Items t
                     * @property {Array.<number>|null} [i] Items i
                     * @property {Array.<number|Long>|null} [l] Items l
                     * @property {Array.<number>|null} [f] Items f
                     * @property {Array.<number>|null} [d] Items d
                     * @property {Array.<boolean>|null} [b] Items b
                     * @property {Array.<string>|null} [s] Items s
                     * @property {Array.<Uint8Array>|null} [bs] Items bs
                     */

                    /**
                     * Constructs a new Items.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents an Items.
                     * @implements IItems
                     * @constructor
                     * @param {cn.beepower.domain.message.IItems=} [properties] Properties to set
                     */
                    function Items(properties) {
                        this.i = [];
                        this.l = [];
                        this.f = [];
                        this.d = [];
                        this.b = [];
                        this.s = [];
                        this.bs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Items t.
                     * @member {string} t
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     */
                    Items.prototype.t = "";

                    /**
                     * Items i.
                     * @member {Array.<number>} i
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     */
                    Items.prototype.i = $util.emptyArray;

                    /**
                     * Items l.
                     * @member {Array.<number|Long>} l
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     */
                    Items.prototype.l = $util.emptyArray;

                    /**
                     * Items f.
                     * @member {Array.<number>} f
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     */
                    Items.prototype.f = $util.emptyArray;

                    /**
                     * Items d.
                     * @member {Array.<number>} d
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     */
                    Items.prototype.d = $util.emptyArray;

                    /**
                     * Items b.
                     * @member {Array.<boolean>} b
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     */
                    Items.prototype.b = $util.emptyArray;

                    /**
                     * Items s.
                     * @member {Array.<string>} s
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     */
                    Items.prototype.s = $util.emptyArray;

                    /**
                     * Items bs.
                     * @member {Array.<Uint8Array>} bs
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     */
                    Items.prototype.bs = $util.emptyArray;

                    /**
                     * Creates a new Items instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Items
                     * @static
                     * @param {cn.beepower.domain.message.IItems=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Items} Items instance
                     */
                    Items.create = function create(properties) {
                        return new Items(properties);
                    };

                    /**
                     * Encodes the specified Items message. Does not implicitly {@link cn.beepower.domain.message.Items.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Items
                     * @static
                     * @param {cn.beepower.domain.message.IItems} message Items message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Items.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.i != null && message.i.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.i.length; ++i)
                                writer.int32(message.i[i]);
                            writer.ldelim();
                        }
                        if (message.l != null && message.l.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.l.length; ++i)
                                writer.int64(message.l[i]);
                            writer.ldelim();
                        }
                        if (message.f != null && message.f.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.f.length; ++i)
                                writer.float(message.f[i]);
                            writer.ldelim();
                        }
                        if (message.d != null && message.d.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.d.length; ++i)
                                writer.double(message.d[i]);
                            writer.ldelim();
                        }
                        if (message.b != null && message.b.length) {
                            writer.uint32(/* id 5, wireType 2 =*/42).fork();
                            for (var i = 0; i < message.b.length; ++i)
                                writer.bool(message.b[i]);
                            writer.ldelim();
                        }
                        if (message.s != null && message.s.length)
                            for (var i = 0; i < message.s.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.s[i]);
                        if (message.bs != null && message.bs.length)
                            for (var i = 0; i < message.bs.length; ++i)
                                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.bs[i]);
                        if (message.t != null && Object.hasOwnProperty.call(message, "t"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.t);
                        return writer;
                    };

                    /**
                     * Encodes the specified Items message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Items.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Items
                     * @static
                     * @param {cn.beepower.domain.message.IItems} message Items message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Items.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Items message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Items
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Items} Items
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Items.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Items();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 15:
                                message.t = reader.string();
                                break;
                            case 1:
                                if (!(message.i && message.i.length))
                                    message.i = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.i.push(reader.int32());
                                } else
                                    message.i.push(reader.int32());
                                break;
                            case 2:
                                if (!(message.l && message.l.length))
                                    message.l = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.l.push(reader.int64());
                                } else
                                    message.l.push(reader.int64());
                                break;
                            case 3:
                                if (!(message.f && message.f.length))
                                    message.f = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.f.push(reader.float());
                                } else
                                    message.f.push(reader.float());
                                break;
                            case 4:
                                if (!(message.d && message.d.length))
                                    message.d = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.d.push(reader.double());
                                } else
                                    message.d.push(reader.double());
                                break;
                            case 5:
                                if (!(message.b && message.b.length))
                                    message.b = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.b.push(reader.bool());
                                } else
                                    message.b.push(reader.bool());
                                break;
                            case 6:
                                if (!(message.s && message.s.length))
                                    message.s = [];
                                message.s.push(reader.string());
                                break;
                            case 7:
                                if (!(message.bs && message.bs.length))
                                    message.bs = [];
                                message.bs.push(reader.bytes());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Items message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Items
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Items} Items
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Items.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Items message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Items
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Items.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.t != null && message.hasOwnProperty("t"))
                            if (!$util.isString(message.t))
                                return "t: string expected";
                        if (message.i != null && message.hasOwnProperty("i")) {
                            if (!Array.isArray(message.i))
                                return "i: array expected";
                            for (var i = 0; i < message.i.length; ++i)
                                if (!$util.isInteger(message.i[i]))
                                    return "i: integer[] expected";
                        }
                        if (message.l != null && message.hasOwnProperty("l")) {
                            if (!Array.isArray(message.l))
                                return "l: array expected";
                            for (var i = 0; i < message.l.length; ++i)
                                if (!$util.isInteger(message.l[i]) && !(message.l[i] && $util.isInteger(message.l[i].low) && $util.isInteger(message.l[i].high)))
                                    return "l: integer|Long[] expected";
                        }
                        if (message.f != null && message.hasOwnProperty("f")) {
                            if (!Array.isArray(message.f))
                                return "f: array expected";
                            for (var i = 0; i < message.f.length; ++i)
                                if (typeof message.f[i] !== "number")
                                    return "f: number[] expected";
                        }
                        if (message.d != null && message.hasOwnProperty("d")) {
                            if (!Array.isArray(message.d))
                                return "d: array expected";
                            for (var i = 0; i < message.d.length; ++i)
                                if (typeof message.d[i] !== "number")
                                    return "d: number[] expected";
                        }
                        if (message.b != null && message.hasOwnProperty("b")) {
                            if (!Array.isArray(message.b))
                                return "b: array expected";
                            for (var i = 0; i < message.b.length; ++i)
                                if (typeof message.b[i] !== "boolean")
                                    return "b: boolean[] expected";
                        }
                        if (message.s != null && message.hasOwnProperty("s")) {
                            if (!Array.isArray(message.s))
                                return "s: array expected";
                            for (var i = 0; i < message.s.length; ++i)
                                if (!$util.isString(message.s[i]))
                                    return "s: string[] expected";
                        }
                        if (message.bs != null && message.hasOwnProperty("bs")) {
                            if (!Array.isArray(message.bs))
                                return "bs: array expected";
                            for (var i = 0; i < message.bs.length; ++i)
                                if (!(message.bs[i] && typeof message.bs[i].length === "number" || $util.isString(message.bs[i])))
                                    return "bs: buffer[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates an Items message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Items
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Items} Items
                     */
                    Items.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Items)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Items();
                        if (object.t != null)
                            message.t = String(object.t);
                        if (object.i) {
                            if (!Array.isArray(object.i))
                                throw TypeError(".cn.beepower.domain.message.Items.i: array expected");
                            message.i = [];
                            for (var i = 0; i < object.i.length; ++i)
                                message.i[i] = object.i[i] | 0;
                        }
                        if (object.l) {
                            if (!Array.isArray(object.l))
                                throw TypeError(".cn.beepower.domain.message.Items.l: array expected");
                            message.l = [];
                            for (var i = 0; i < object.l.length; ++i)
                                if ($util.Long)
                                    (message.l[i] = $util.Long.fromValue(object.l[i])).unsigned = false;
                                else if (typeof object.l[i] === "string")
                                    message.l[i] = parseInt(object.l[i], 10);
                                else if (typeof object.l[i] === "number")
                                    message.l[i] = object.l[i];
                                else if (typeof object.l[i] === "object")
                                    message.l[i] = new $util.LongBits(object.l[i].low >>> 0, object.l[i].high >>> 0).toNumber();
                        }
                        if (object.f) {
                            if (!Array.isArray(object.f))
                                throw TypeError(".cn.beepower.domain.message.Items.f: array expected");
                            message.f = [];
                            for (var i = 0; i < object.f.length; ++i)
                                message.f[i] = Number(object.f[i]);
                        }
                        if (object.d) {
                            if (!Array.isArray(object.d))
                                throw TypeError(".cn.beepower.domain.message.Items.d: array expected");
                            message.d = [];
                            for (var i = 0; i < object.d.length; ++i)
                                message.d[i] = Number(object.d[i]);
                        }
                        if (object.b) {
                            if (!Array.isArray(object.b))
                                throw TypeError(".cn.beepower.domain.message.Items.b: array expected");
                            message.b = [];
                            for (var i = 0; i < object.b.length; ++i)
                                message.b[i] = Boolean(object.b[i]);
                        }
                        if (object.s) {
                            if (!Array.isArray(object.s))
                                throw TypeError(".cn.beepower.domain.message.Items.s: array expected");
                            message.s = [];
                            for (var i = 0; i < object.s.length; ++i)
                                message.s[i] = String(object.s[i]);
                        }
                        if (object.bs) {
                            if (!Array.isArray(object.bs))
                                throw TypeError(".cn.beepower.domain.message.Items.bs: array expected");
                            message.bs = [];
                            for (var i = 0; i < object.bs.length; ++i)
                                if (typeof object.bs[i] === "string")
                                    $util.base64.decode(object.bs[i], message.bs[i] = $util.newBuffer($util.base64.length(object.bs[i])), 0);
                                else if (object.bs[i].length)
                                    message.bs[i] = object.bs[i];
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from an Items message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Items
                     * @static
                     * @param {cn.beepower.domain.message.Items} message Items
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Items.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.i = [];
                            object.l = [];
                            object.f = [];
                            object.d = [];
                            object.b = [];
                            object.s = [];
                            object.bs = [];
                        }
                        if (options.defaults)
                            object.t = "";
                        if (message.i && message.i.length) {
                            object.i = [];
                            for (var j = 0; j < message.i.length; ++j)
                                object.i[j] = message.i[j];
                        }
                        if (message.l && message.l.length) {
                            object.l = [];
                            for (var j = 0; j < message.l.length; ++j)
                                if (typeof message.l[j] === "number")
                                    object.l[j] = options.longs === String ? String(message.l[j]) : message.l[j];
                                else
                                    object.l[j] = options.longs === String ? $util.Long.prototype.toString.call(message.l[j]) : options.longs === Number ? new $util.LongBits(message.l[j].low >>> 0, message.l[j].high >>> 0).toNumber() : message.l[j];
                        }
                        if (message.f && message.f.length) {
                            object.f = [];
                            for (var j = 0; j < message.f.length; ++j)
                                object.f[j] = options.json && !isFinite(message.f[j]) ? String(message.f[j]) : message.f[j];
                        }
                        if (message.d && message.d.length) {
                            object.d = [];
                            for (var j = 0; j < message.d.length; ++j)
                                object.d[j] = options.json && !isFinite(message.d[j]) ? String(message.d[j]) : message.d[j];
                        }
                        if (message.b && message.b.length) {
                            object.b = [];
                            for (var j = 0; j < message.b.length; ++j)
                                object.b[j] = message.b[j];
                        }
                        if (message.s && message.s.length) {
                            object.s = [];
                            for (var j = 0; j < message.s.length; ++j)
                                object.s[j] = message.s[j];
                        }
                        if (message.bs && message.bs.length) {
                            object.bs = [];
                            for (var j = 0; j < message.bs.length; ++j)
                                object.bs[j] = options.bytes === String ? $util.base64.encode(message.bs[j], 0, message.bs[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.bs[j]) : message.bs[j];
                        }
                        if (message.t != null && message.hasOwnProperty("t"))
                            object.t = message.t;
                        return object;
                    };

                    /**
                     * Converts this Items to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Items
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Items.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Items;
                })();

                message.Series = (function() {

                    /**
                     * Properties of a Series.
                     * @memberof cn.beepower.domain.message
                     * @interface ISeries
                     * @property {string|null} [dbName] Series dbName
                     * @property {string|null} [mapName] Series mapName
                     * @property {cn.beepower.domain.message.IItem|null} [property] Series property
                     * @property {cn.beepower.domain.message.IItems|null} [keys] Series keys
                     * @property {cn.beepower.domain.message.IItems|null} [values] Series values
                     */

                    /**
                     * Constructs a new Series.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a Series.
                     * @implements ISeries
                     * @constructor
                     * @param {cn.beepower.domain.message.ISeries=} [properties] Properties to set
                     */
                    function Series(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Series dbName.
                     * @member {string} dbName
                     * @memberof cn.beepower.domain.message.Series
                     * @instance
                     */
                    Series.prototype.dbName = "";

                    /**
                     * Series mapName.
                     * @member {string} mapName
                     * @memberof cn.beepower.domain.message.Series
                     * @instance
                     */
                    Series.prototype.mapName = "";

                    /**
                     * Series property.
                     * @member {cn.beepower.domain.message.IItem|null|undefined} property
                     * @memberof cn.beepower.domain.message.Series
                     * @instance
                     */
                    Series.prototype.property = null;

                    /**
                     * Series keys.
                     * @member {cn.beepower.domain.message.IItems|null|undefined} keys
                     * @memberof cn.beepower.domain.message.Series
                     * @instance
                     */
                    Series.prototype.keys = null;

                    /**
                     * Series values.
                     * @member {cn.beepower.domain.message.IItems|null|undefined} values
                     * @memberof cn.beepower.domain.message.Series
                     * @instance
                     */
                    Series.prototype.values = null;

                    /**
                     * Creates a new Series instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Series
                     * @static
                     * @param {cn.beepower.domain.message.ISeries=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Series} Series instance
                     */
                    Series.create = function create(properties) {
                        return new Series(properties);
                    };

                    /**
                     * Encodes the specified Series message. Does not implicitly {@link cn.beepower.domain.message.Series.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Series
                     * @static
                     * @param {cn.beepower.domain.message.ISeries} message Series message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Series.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dbName != null && Object.hasOwnProperty.call(message, "dbName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.dbName);
                        if (message.mapName != null && Object.hasOwnProperty.call(message, "mapName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.mapName);
                        if (message.property != null && Object.hasOwnProperty.call(message, "property"))
                            $root.cn.beepower.domain.message.Item.encode(message.property, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.keys != null && Object.hasOwnProperty.call(message, "keys"))
                            $root.cn.beepower.domain.message.Items.encode(message.keys, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.values != null && Object.hasOwnProperty.call(message, "values"))
                            $root.cn.beepower.domain.message.Items.encode(message.values, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified Series message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Series.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Series
                     * @static
                     * @param {cn.beepower.domain.message.ISeries} message Series message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Series.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Series message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Series
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Series} Series
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Series.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Series();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dbName = reader.string();
                                break;
                            case 2:
                                message.mapName = reader.string();
                                break;
                            case 5:
                                message.property = $root.cn.beepower.domain.message.Item.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.keys = $root.cn.beepower.domain.message.Items.decode(reader, reader.uint32());
                                break;
                            case 15:
                                message.values = $root.cn.beepower.domain.message.Items.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Series message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Series
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Series} Series
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Series.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Series message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Series
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Series.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dbName != null && message.hasOwnProperty("dbName"))
                            if (!$util.isString(message.dbName))
                                return "dbName: string expected";
                        if (message.mapName != null && message.hasOwnProperty("mapName"))
                            if (!$util.isString(message.mapName))
                                return "mapName: string expected";
                        if (message.property != null && message.hasOwnProperty("property")) {
                            var error = $root.cn.beepower.domain.message.Item.verify(message.property);
                            if (error)
                                return "property." + error;
                        }
                        if (message.keys != null && message.hasOwnProperty("keys")) {
                            var error = $root.cn.beepower.domain.message.Items.verify(message.keys);
                            if (error)
                                return "keys." + error;
                        }
                        if (message.values != null && message.hasOwnProperty("values")) {
                            var error = $root.cn.beepower.domain.message.Items.verify(message.values);
                            if (error)
                                return "values." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a Series message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Series
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Series} Series
                     */
                    Series.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Series)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Series();
                        if (object.dbName != null)
                            message.dbName = String(object.dbName);
                        if (object.mapName != null)
                            message.mapName = String(object.mapName);
                        if (object.property != null) {
                            if (typeof object.property !== "object")
                                throw TypeError(".cn.beepower.domain.message.Series.property: object expected");
                            message.property = $root.cn.beepower.domain.message.Item.fromObject(object.property);
                        }
                        if (object.keys != null) {
                            if (typeof object.keys !== "object")
                                throw TypeError(".cn.beepower.domain.message.Series.keys: object expected");
                            message.keys = $root.cn.beepower.domain.message.Items.fromObject(object.keys);
                        }
                        if (object.values != null) {
                            if (typeof object.values !== "object")
                                throw TypeError(".cn.beepower.domain.message.Series.values: object expected");
                            message.values = $root.cn.beepower.domain.message.Items.fromObject(object.values);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a Series message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Series
                     * @static
                     * @param {cn.beepower.domain.message.Series} message Series
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Series.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dbName = "";
                            object.mapName = "";
                            object.property = null;
                            object.keys = null;
                            object.values = null;
                        }
                        if (message.dbName != null && message.hasOwnProperty("dbName"))
                            object.dbName = message.dbName;
                        if (message.mapName != null && message.hasOwnProperty("mapName"))
                            object.mapName = message.mapName;
                        if (message.property != null && message.hasOwnProperty("property"))
                            object.property = $root.cn.beepower.domain.message.Item.toObject(message.property, options);
                        if (message.keys != null && message.hasOwnProperty("keys"))
                            object.keys = $root.cn.beepower.domain.message.Items.toObject(message.keys, options);
                        if (message.values != null && message.hasOwnProperty("values"))
                            object.values = $root.cn.beepower.domain.message.Items.toObject(message.values, options);
                        return object;
                    };

                    /**
                     * Converts this Series to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Series
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Series.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Series;
                })();

                message.MeasureValueParser = (function() {

                    /**
                     * Properties of a MeasureValueParser.
                     * @memberof cn.beepower.domain.message
                     * @interface IMeasureValueParser
                     * @property {string|null} [name] MeasureValueParser name
                     * @property {number|null} [precision] MeasureValueParser precision
                     * @property {number|null} [count] MeasureValueParser count
                     * @property {number|null} [threshold] MeasureValueParser threshold
                     * @property {number|null} [multiplier] MeasureValueParser multiplier
                     * @property {number|null} [lowerBound] MeasureValueParser lowerBound
                     * @property {number|null} [upperBound] MeasureValueParser upperBound
                     */

                    /**
                     * Constructs a new MeasureValueParser.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a MeasureValueParser.
                     * @implements IMeasureValueParser
                     * @constructor
                     * @param {cn.beepower.domain.message.IMeasureValueParser=} [properties] Properties to set
                     */
                    function MeasureValueParser(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * MeasureValueParser name.
                     * @member {string} name
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @instance
                     */
                    MeasureValueParser.prototype.name = "";

                    /**
                     * MeasureValueParser precision.
                     * @member {number} precision
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @instance
                     */
                    MeasureValueParser.prototype.precision = 0;

                    /**
                     * MeasureValueParser count.
                     * @member {number} count
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @instance
                     */
                    MeasureValueParser.prototype.count = 0;

                    /**
                     * MeasureValueParser threshold.
                     * @member {number} threshold
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @instance
                     */
                    MeasureValueParser.prototype.threshold = 0;

                    /**
                     * MeasureValueParser multiplier.
                     * @member {number} multiplier
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @instance
                     */
                    MeasureValueParser.prototype.multiplier = 0;

                    /**
                     * MeasureValueParser lowerBound.
                     * @member {number} lowerBound
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @instance
                     */
                    MeasureValueParser.prototype.lowerBound = 0;

                    /**
                     * MeasureValueParser upperBound.
                     * @member {number} upperBound
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @instance
                     */
                    MeasureValueParser.prototype.upperBound = 0;

                    /**
                     * Creates a new MeasureValueParser instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @static
                     * @param {cn.beepower.domain.message.IMeasureValueParser=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.MeasureValueParser} MeasureValueParser instance
                     */
                    MeasureValueParser.create = function create(properties) {
                        return new MeasureValueParser(properties);
                    };

                    /**
                     * Encodes the specified MeasureValueParser message. Does not implicitly {@link cn.beepower.domain.message.MeasureValueParser.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @static
                     * @param {cn.beepower.domain.message.IMeasureValueParser} message MeasureValueParser message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MeasureValueParser.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.precision != null && Object.hasOwnProperty.call(message, "precision"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.precision);
                        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.count);
                        if (message.threshold != null && Object.hasOwnProperty.call(message, "threshold"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.threshold);
                        if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                            writer.uint32(/* id 6, wireType 5 =*/53).float(message.multiplier);
                        if (message.lowerBound != null && Object.hasOwnProperty.call(message, "lowerBound"))
                            writer.uint32(/* id 10, wireType 5 =*/85).float(message.lowerBound);
                        if (message.upperBound != null && Object.hasOwnProperty.call(message, "upperBound"))
                            writer.uint32(/* id 11, wireType 5 =*/93).float(message.upperBound);
                        return writer;
                    };

                    /**
                     * Encodes the specified MeasureValueParser message, length delimited. Does not implicitly {@link cn.beepower.domain.message.MeasureValueParser.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @static
                     * @param {cn.beepower.domain.message.IMeasureValueParser} message MeasureValueParser message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MeasureValueParser.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a MeasureValueParser message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.MeasureValueParser} MeasureValueParser
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MeasureValueParser.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.MeasureValueParser();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.precision = reader.int32();
                                break;
                            case 3:
                                message.count = reader.int32();
                                break;
                            case 5:
                                message.threshold = reader.float();
                                break;
                            case 6:
                                message.multiplier = reader.float();
                                break;
                            case 10:
                                message.lowerBound = reader.float();
                                break;
                            case 11:
                                message.upperBound = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a MeasureValueParser message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.MeasureValueParser} MeasureValueParser
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MeasureValueParser.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a MeasureValueParser message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MeasureValueParser.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.precision != null && message.hasOwnProperty("precision"))
                            if (!$util.isInteger(message.precision))
                                return "precision: integer expected";
                        if (message.count != null && message.hasOwnProperty("count"))
                            if (!$util.isInteger(message.count))
                                return "count: integer expected";
                        if (message.threshold != null && message.hasOwnProperty("threshold"))
                            if (typeof message.threshold !== "number")
                                return "threshold: number expected";
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            if (typeof message.multiplier !== "number")
                                return "multiplier: number expected";
                        if (message.lowerBound != null && message.hasOwnProperty("lowerBound"))
                            if (typeof message.lowerBound !== "number")
                                return "lowerBound: number expected";
                        if (message.upperBound != null && message.hasOwnProperty("upperBound"))
                            if (typeof message.upperBound !== "number")
                                return "upperBound: number expected";
                        return null;
                    };

                    /**
                     * Creates a MeasureValueParser message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.MeasureValueParser} MeasureValueParser
                     */
                    MeasureValueParser.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.MeasureValueParser)
                            return object;
                        var message = new $root.cn.beepower.domain.message.MeasureValueParser();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.precision != null)
                            message.precision = object.precision | 0;
                        if (object.count != null)
                            message.count = object.count | 0;
                        if (object.threshold != null)
                            message.threshold = Number(object.threshold);
                        if (object.multiplier != null)
                            message.multiplier = Number(object.multiplier);
                        if (object.lowerBound != null)
                            message.lowerBound = Number(object.lowerBound);
                        if (object.upperBound != null)
                            message.upperBound = Number(object.upperBound);
                        return message;
                    };

                    /**
                     * Creates a plain object from a MeasureValueParser message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @static
                     * @param {cn.beepower.domain.message.MeasureValueParser} message MeasureValueParser
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MeasureValueParser.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.precision = 0;
                            object.count = 0;
                            object.threshold = 0;
                            object.multiplier = 0;
                            object.lowerBound = 0;
                            object.upperBound = 0;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.precision != null && message.hasOwnProperty("precision"))
                            object.precision = message.precision;
                        if (message.count != null && message.hasOwnProperty("count"))
                            object.count = message.count;
                        if (message.threshold != null && message.hasOwnProperty("threshold"))
                            object.threshold = options.json && !isFinite(message.threshold) ? String(message.threshold) : message.threshold;
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
                        if (message.lowerBound != null && message.hasOwnProperty("lowerBound"))
                            object.lowerBound = options.json && !isFinite(message.lowerBound) ? String(message.lowerBound) : message.lowerBound;
                        if (message.upperBound != null && message.hasOwnProperty("upperBound"))
                            object.upperBound = options.json && !isFinite(message.upperBound) ? String(message.upperBound) : message.upperBound;
                        return object;
                    };

                    /**
                     * Converts this MeasureValueParser to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.MeasureValueParser
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MeasureValueParser.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return MeasureValueParser;
                })();

                message.MeasureValue = (function() {

                    /**
                     * Properties of a MeasureValue.
                     * @memberof cn.beepower.domain.message
                     * @interface IMeasureValue
                     * @property {string|null} [id] MeasureValue id
                     * @property {number|Long|null} [t] MeasureValue t
                     * @property {number|null} [register] MeasureValue register
                     * @property {number|null} [amount] MeasureValue amount
                     * @property {Array.<number>|null} [value] MeasureValue value
                     * @property {Array.<number>|null} [result] MeasureValue result
                     * @property {Array.<string>|null} [alias] MeasureValue alias
                     * @property {Array.<string>|null} [strResult] MeasureValue strResult
                     * @property {Array.<boolean>|null} [isAbnormal] MeasureValue isAbnormal
                     */

                    /**
                     * Constructs a new MeasureValue.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a MeasureValue.
                     * @implements IMeasureValue
                     * @constructor
                     * @param {cn.beepower.domain.message.IMeasureValue=} [properties] Properties to set
                     */
                    function MeasureValue(properties) {
                        this.value = [];
                        this.result = [];
                        this.alias = [];
                        this.strResult = [];
                        this.isAbnormal = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * MeasureValue id.
                     * @member {string} id
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.id = "";

                    /**
                     * MeasureValue t.
                     * @member {number|Long} t
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.t = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * MeasureValue register.
                     * @member {number} register
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.register = 0;

                    /**
                     * MeasureValue amount.
                     * @member {number} amount
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.amount = 0;

                    /**
                     * MeasureValue value.
                     * @member {Array.<number>} value
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.value = $util.emptyArray;

                    /**
                     * MeasureValue result.
                     * @member {Array.<number>} result
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.result = $util.emptyArray;

                    /**
                     * MeasureValue alias.
                     * @member {Array.<string>} alias
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.alias = $util.emptyArray;

                    /**
                     * MeasureValue strResult.
                     * @member {Array.<string>} strResult
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.strResult = $util.emptyArray;

                    /**
                     * MeasureValue isAbnormal.
                     * @member {Array.<boolean>} isAbnormal
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     */
                    MeasureValue.prototype.isAbnormal = $util.emptyArray;

                    /**
                     * Creates a new MeasureValue instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @static
                     * @param {cn.beepower.domain.message.IMeasureValue=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.MeasureValue} MeasureValue instance
                     */
                    MeasureValue.create = function create(properties) {
                        return new MeasureValue(properties);
                    };

                    /**
                     * Encodes the specified MeasureValue message. Does not implicitly {@link cn.beepower.domain.message.MeasureValue.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @static
                     * @param {cn.beepower.domain.message.IMeasureValue} message MeasureValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MeasureValue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.t != null && Object.hasOwnProperty.call(message, "t"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.t);
                        if (message.register != null && Object.hasOwnProperty.call(message, "register"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.register);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.amount);
                        if (message.value != null && message.value.length) {
                            writer.uint32(/* id 7, wireType 2 =*/58).fork();
                            for (var i = 0; i < message.value.length; ++i)
                                writer.int32(message.value[i]);
                            writer.ldelim();
                        }
                        if (message.result != null && message.result.length) {
                            writer.uint32(/* id 10, wireType 2 =*/82).fork();
                            for (var i = 0; i < message.result.length; ++i)
                                writer.float(message.result[i]);
                            writer.ldelim();
                        }
                        if (message.alias != null && message.alias.length)
                            for (var i = 0; i < message.alias.length; ++i)
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.alias[i]);
                        if (message.strResult != null && message.strResult.length)
                            for (var i = 0; i < message.strResult.length; ++i)
                                writer.uint32(/* id 12, wireType 2 =*/98).string(message.strResult[i]);
                        if (message.isAbnormal != null && message.isAbnormal.length) {
                            writer.uint32(/* id 13, wireType 2 =*/106).fork();
                            for (var i = 0; i < message.isAbnormal.length; ++i)
                                writer.bool(message.isAbnormal[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };

                    /**
                     * Encodes the specified MeasureValue message, length delimited. Does not implicitly {@link cn.beepower.domain.message.MeasureValue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @static
                     * @param {cn.beepower.domain.message.IMeasureValue} message MeasureValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MeasureValue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a MeasureValue message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.MeasureValue} MeasureValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MeasureValue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.MeasureValue();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.string();
                                break;
                            case 2:
                                message.t = reader.int64();
                                break;
                            case 5:
                                message.register = reader.int32();
                                break;
                            case 6:
                                message.amount = reader.int32();
                                break;
                            case 7:
                                if (!(message.value && message.value.length))
                                    message.value = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.value.push(reader.int32());
                                } else
                                    message.value.push(reader.int32());
                                break;
                            case 10:
                                if (!(message.result && message.result.length))
                                    message.result = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.result.push(reader.float());
                                } else
                                    message.result.push(reader.float());
                                break;
                            case 11:
                                if (!(message.alias && message.alias.length))
                                    message.alias = [];
                                message.alias.push(reader.string());
                                break;
                            case 12:
                                if (!(message.strResult && message.strResult.length))
                                    message.strResult = [];
                                message.strResult.push(reader.string());
                                break;
                            case 13:
                                if (!(message.isAbnormal && message.isAbnormal.length))
                                    message.isAbnormal = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.isAbnormal.push(reader.bool());
                                } else
                                    message.isAbnormal.push(reader.bool());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a MeasureValue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.MeasureValue} MeasureValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MeasureValue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a MeasureValue message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MeasureValue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.t != null && message.hasOwnProperty("t"))
                            if (!$util.isInteger(message.t) && !(message.t && $util.isInteger(message.t.low) && $util.isInteger(message.t.high)))
                                return "t: integer|Long expected";
                        if (message.register != null && message.hasOwnProperty("register"))
                            if (!$util.isInteger(message.register))
                                return "register: integer expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (!$util.isInteger(message.amount))
                                return "amount: integer expected";
                        if (message.value != null && message.hasOwnProperty("value")) {
                            if (!Array.isArray(message.value))
                                return "value: array expected";
                            for (var i = 0; i < message.value.length; ++i)
                                if (!$util.isInteger(message.value[i]))
                                    return "value: integer[] expected";
                        }
                        if (message.result != null && message.hasOwnProperty("result")) {
                            if (!Array.isArray(message.result))
                                return "result: array expected";
                            for (var i = 0; i < message.result.length; ++i)
                                if (typeof message.result[i] !== "number")
                                    return "result: number[] expected";
                        }
                        if (message.alias != null && message.hasOwnProperty("alias")) {
                            if (!Array.isArray(message.alias))
                                return "alias: array expected";
                            for (var i = 0; i < message.alias.length; ++i)
                                if (!$util.isString(message.alias[i]))
                                    return "alias: string[] expected";
                        }
                        if (message.strResult != null && message.hasOwnProperty("strResult")) {
                            if (!Array.isArray(message.strResult))
                                return "strResult: array expected";
                            for (var i = 0; i < message.strResult.length; ++i)
                                if (!$util.isString(message.strResult[i]))
                                    return "strResult: string[] expected";
                        }
                        if (message.isAbnormal != null && message.hasOwnProperty("isAbnormal")) {
                            if (!Array.isArray(message.isAbnormal))
                                return "isAbnormal: array expected";
                            for (var i = 0; i < message.isAbnormal.length; ++i)
                                if (typeof message.isAbnormal[i] !== "boolean")
                                    return "isAbnormal: boolean[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a MeasureValue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.MeasureValue} MeasureValue
                     */
                    MeasureValue.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.MeasureValue)
                            return object;
                        var message = new $root.cn.beepower.domain.message.MeasureValue();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.t != null)
                            if ($util.Long)
                                (message.t = $util.Long.fromValue(object.t)).unsigned = false;
                            else if (typeof object.t === "string")
                                message.t = parseInt(object.t, 10);
                            else if (typeof object.t === "number")
                                message.t = object.t;
                            else if (typeof object.t === "object")
                                message.t = new $util.LongBits(object.t.low >>> 0, object.t.high >>> 0).toNumber();
                        if (object.register != null)
                            message.register = object.register | 0;
                        if (object.amount != null)
                            message.amount = object.amount | 0;
                        if (object.value) {
                            if (!Array.isArray(object.value))
                                throw TypeError(".cn.beepower.domain.message.MeasureValue.value: array expected");
                            message.value = [];
                            for (var i = 0; i < object.value.length; ++i)
                                message.value[i] = object.value[i] | 0;
                        }
                        if (object.result) {
                            if (!Array.isArray(object.result))
                                throw TypeError(".cn.beepower.domain.message.MeasureValue.result: array expected");
                            message.result = [];
                            for (var i = 0; i < object.result.length; ++i)
                                message.result[i] = Number(object.result[i]);
                        }
                        if (object.alias) {
                            if (!Array.isArray(object.alias))
                                throw TypeError(".cn.beepower.domain.message.MeasureValue.alias: array expected");
                            message.alias = [];
                            for (var i = 0; i < object.alias.length; ++i)
                                message.alias[i] = String(object.alias[i]);
                        }
                        if (object.strResult) {
                            if (!Array.isArray(object.strResult))
                                throw TypeError(".cn.beepower.domain.message.MeasureValue.strResult: array expected");
                            message.strResult = [];
                            for (var i = 0; i < object.strResult.length; ++i)
                                message.strResult[i] = String(object.strResult[i]);
                        }
                        if (object.isAbnormal) {
                            if (!Array.isArray(object.isAbnormal))
                                throw TypeError(".cn.beepower.domain.message.MeasureValue.isAbnormal: array expected");
                            message.isAbnormal = [];
                            for (var i = 0; i < object.isAbnormal.length; ++i)
                                message.isAbnormal[i] = Boolean(object.isAbnormal[i]);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a MeasureValue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @static
                     * @param {cn.beepower.domain.message.MeasureValue} message MeasureValue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MeasureValue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.value = [];
                            object.result = [];
                            object.alias = [];
                            object.strResult = [];
                            object.isAbnormal = [];
                        }
                        if (options.defaults) {
                            object.id = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.t = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.t = options.longs === String ? "0" : 0;
                            object.register = 0;
                            object.amount = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.t != null && message.hasOwnProperty("t"))
                            if (typeof message.t === "number")
                                object.t = options.longs === String ? String(message.t) : message.t;
                            else
                                object.t = options.longs === String ? $util.Long.prototype.toString.call(message.t) : options.longs === Number ? new $util.LongBits(message.t.low >>> 0, message.t.high >>> 0).toNumber() : message.t;
                        if (message.register != null && message.hasOwnProperty("register"))
                            object.register = message.register;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = message.amount;
                        if (message.value && message.value.length) {
                            object.value = [];
                            for (var j = 0; j < message.value.length; ++j)
                                object.value[j] = message.value[j];
                        }
                        if (message.result && message.result.length) {
                            object.result = [];
                            for (var j = 0; j < message.result.length; ++j)
                                object.result[j] = options.json && !isFinite(message.result[j]) ? String(message.result[j]) : message.result[j];
                        }
                        if (message.alias && message.alias.length) {
                            object.alias = [];
                            for (var j = 0; j < message.alias.length; ++j)
                                object.alias[j] = message.alias[j];
                        }
                        if (message.strResult && message.strResult.length) {
                            object.strResult = [];
                            for (var j = 0; j < message.strResult.length; ++j)
                                object.strResult[j] = message.strResult[j];
                        }
                        if (message.isAbnormal && message.isAbnormal.length) {
                            object.isAbnormal = [];
                            for (var j = 0; j < message.isAbnormal.length; ++j)
                                object.isAbnormal[j] = message.isAbnormal[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this MeasureValue to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.MeasureValue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MeasureValue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return MeasureValue;
                })();

                message.Command = (function() {

                    /**
                     * Properties of a Command.
                     * @memberof cn.beepower.domain.message
                     * @interface ICommand
                     * @property {string|null} [id] Command id
                     * @property {string|null} [protocol] Command protocol
                     * @property {string|null} [topic] Command topic
                     * @property {number|null} [register] Command register
                     * @property {number|null} [amount] Command amount
                     * @property {Uint8Array|null} [detail] Command detail
                     * @property {boolean|null} [isAnalog] Command isAnalog
                     * @property {boolean|null} [isOutputRegister] Command isOutputRegister
                     * @property {boolean|null} [using0F10ToWriteSingle] Command using0F10ToWriteSingle
                     * @property {string|null} [name] Command name
                     * @property {string|null} [description] Command description
                     */

                    /**
                     * Constructs a new Command.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a Command.
                     * @implements ICommand
                     * @constructor
                     * @param {cn.beepower.domain.message.ICommand=} [properties] Properties to set
                     */
                    function Command(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Command id.
                     * @member {string} id
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.id = "";

                    /**
                     * Command protocol.
                     * @member {string} protocol
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.protocol = "";

                    /**
                     * Command topic.
                     * @member {string} topic
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.topic = "";

                    /**
                     * Command register.
                     * @member {number} register
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.register = 0;

                    /**
                     * Command amount.
                     * @member {number} amount
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.amount = 0;

                    /**
                     * Command detail.
                     * @member {Uint8Array} detail
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.detail = $util.newBuffer([]);

                    /**
                     * Command isAnalog.
                     * @member {boolean} isAnalog
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.isAnalog = false;

                    /**
                     * Command isOutputRegister.
                     * @member {boolean} isOutputRegister
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.isOutputRegister = false;

                    /**
                     * Command using0F10ToWriteSingle.
                     * @member {boolean} using0F10ToWriteSingle
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.using0F10ToWriteSingle = false;

                    /**
                     * Command name.
                     * @member {string} name
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.name = "";

                    /**
                     * Command description.
                     * @member {string} description
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     */
                    Command.prototype.description = "";

                    /**
                     * Creates a new Command instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Command
                     * @static
                     * @param {cn.beepower.domain.message.ICommand=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Command} Command instance
                     */
                    Command.create = function create(properties) {
                        return new Command(properties);
                    };

                    /**
                     * Encodes the specified Command message. Does not implicitly {@link cn.beepower.domain.message.Command.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Command
                     * @static
                     * @param {cn.beepower.domain.message.ICommand} message Command message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Command.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.protocol != null && Object.hasOwnProperty.call(message, "protocol"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.protocol);
                        if (message.topic != null && Object.hasOwnProperty.call(message, "topic"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.topic);
                        if (message.register != null && Object.hasOwnProperty.call(message, "register"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.register);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.amount);
                        if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
                            writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.detail);
                        if (message.isAnalog != null && Object.hasOwnProperty.call(message, "isAnalog"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isAnalog);
                        if (message.isOutputRegister != null && Object.hasOwnProperty.call(message, "isOutputRegister"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isOutputRegister);
                        if (message.using0F10ToWriteSingle != null && Object.hasOwnProperty.call(message, "using0F10ToWriteSingle"))
                            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.using0F10ToWriteSingle);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.description);
                        return writer;
                    };

                    /**
                     * Encodes the specified Command message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Command.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Command
                     * @static
                     * @param {cn.beepower.domain.message.ICommand} message Command message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Command.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Command message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Command
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Command} Command
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Command.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Command();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.string();
                                break;
                            case 2:
                                message.protocol = reader.string();
                                break;
                            case 3:
                                message.topic = reader.string();
                                break;
                            case 5:
                                message.register = reader.int32();
                                break;
                            case 6:
                                message.amount = reader.int32();
                                break;
                            case 7:
                                message.detail = reader.bytes();
                                break;
                            case 10:
                                message.isAnalog = reader.bool();
                                break;
                            case 11:
                                message.isOutputRegister = reader.bool();
                                break;
                            case 12:
                                message.using0F10ToWriteSingle = reader.bool();
                                break;
                            case 14:
                                message.name = reader.string();
                                break;
                            case 15:
                                message.description = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Command message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Command
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Command} Command
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Command.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Command message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Command
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Command.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.protocol != null && message.hasOwnProperty("protocol"))
                            if (!$util.isString(message.protocol))
                                return "protocol: string expected";
                        if (message.topic != null && message.hasOwnProperty("topic"))
                            if (!$util.isString(message.topic))
                                return "topic: string expected";
                        if (message.register != null && message.hasOwnProperty("register"))
                            if (!$util.isInteger(message.register))
                                return "register: integer expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (!$util.isInteger(message.amount))
                                return "amount: integer expected";
                        if (message.detail != null && message.hasOwnProperty("detail"))
                            if (!(message.detail && typeof message.detail.length === "number" || $util.isString(message.detail)))
                                return "detail: buffer expected";
                        if (message.isAnalog != null && message.hasOwnProperty("isAnalog"))
                            if (typeof message.isAnalog !== "boolean")
                                return "isAnalog: boolean expected";
                        if (message.isOutputRegister != null && message.hasOwnProperty("isOutputRegister"))
                            if (typeof message.isOutputRegister !== "boolean")
                                return "isOutputRegister: boolean expected";
                        if (message.using0F10ToWriteSingle != null && message.hasOwnProperty("using0F10ToWriteSingle"))
                            if (typeof message.using0F10ToWriteSingle !== "boolean")
                                return "using0F10ToWriteSingle: boolean expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        return null;
                    };

                    /**
                     * Creates a Command message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Command
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Command} Command
                     */
                    Command.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Command)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Command();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.protocol != null)
                            message.protocol = String(object.protocol);
                        if (object.topic != null)
                            message.topic = String(object.topic);
                        if (object.register != null)
                            message.register = object.register | 0;
                        if (object.amount != null)
                            message.amount = object.amount | 0;
                        if (object.detail != null)
                            if (typeof object.detail === "string")
                                $util.base64.decode(object.detail, message.detail = $util.newBuffer($util.base64.length(object.detail)), 0);
                            else if (object.detail.length)
                                message.detail = object.detail;
                        if (object.isAnalog != null)
                            message.isAnalog = Boolean(object.isAnalog);
                        if (object.isOutputRegister != null)
                            message.isOutputRegister = Boolean(object.isOutputRegister);
                        if (object.using0F10ToWriteSingle != null)
                            message.using0F10ToWriteSingle = Boolean(object.using0F10ToWriteSingle);
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Command message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Command
                     * @static
                     * @param {cn.beepower.domain.message.Command} message Command
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Command.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.id = "";
                            object.protocol = "";
                            object.topic = "";
                            object.register = 0;
                            object.amount = 0;
                            if (options.bytes === String)
                                object.detail = "";
                            else {
                                object.detail = [];
                                if (options.bytes !== Array)
                                    object.detail = $util.newBuffer(object.detail);
                            }
                            object.isAnalog = false;
                            object.isOutputRegister = false;
                            object.using0F10ToWriteSingle = false;
                            object.name = "";
                            object.description = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.protocol != null && message.hasOwnProperty("protocol"))
                            object.protocol = message.protocol;
                        if (message.topic != null && message.hasOwnProperty("topic"))
                            object.topic = message.topic;
                        if (message.register != null && message.hasOwnProperty("register"))
                            object.register = message.register;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = message.amount;
                        if (message.detail != null && message.hasOwnProperty("detail"))
                            object.detail = options.bytes === String ? $util.base64.encode(message.detail, 0, message.detail.length) : options.bytes === Array ? Array.prototype.slice.call(message.detail) : message.detail;
                        if (message.isAnalog != null && message.hasOwnProperty("isAnalog"))
                            object.isAnalog = message.isAnalog;
                        if (message.isOutputRegister != null && message.hasOwnProperty("isOutputRegister"))
                            object.isOutputRegister = message.isOutputRegister;
                        if (message.using0F10ToWriteSingle != null && message.hasOwnProperty("using0F10ToWriteSingle"))
                            object.using0F10ToWriteSingle = message.using0F10ToWriteSingle;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        return object;
                    };

                    /**
                     * Converts this Command to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Command
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Command.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Command;
                })();

                message.Instructions = (function() {

                    /**
                     * Properties of an Instructions.
                     * @memberof cn.beepower.domain.message
                     * @interface IInstructions
                     * @property {string|null} [topic] Instructions topic
                     * @property {Array.<cn.beepower.domain.message.ICommand>|null} [commands] Instructions commands
                     * @property {Array.<number>|null} [delayInMillis] Instructions delayInMillis
                     * @property {string|null} [imageId] Instructions imageId
                     * @property {string|null} [cronTrigger] Instructions cronTrigger
                     * @property {number|null} [retryNum] Instructions retryNum
                     * @property {string|null} [execMode] Instructions execMode
                     * @property {string|null} [name] Instructions name
                     * @property {boolean|null} [enabled] Instructions enabled
                     */

                    /**
                     * Constructs a new Instructions.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents an Instructions.
                     * @implements IInstructions
                     * @constructor
                     * @param {cn.beepower.domain.message.IInstructions=} [properties] Properties to set
                     */
                    function Instructions(properties) {
                        this.commands = [];
                        this.delayInMillis = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Instructions topic.
                     * @member {string} topic
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.topic = "";

                    /**
                     * Instructions commands.
                     * @member {Array.<cn.beepower.domain.message.ICommand>} commands
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.commands = $util.emptyArray;

                    /**
                     * Instructions delayInMillis.
                     * @member {Array.<number>} delayInMillis
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.delayInMillis = $util.emptyArray;

                    /**
                     * Instructions imageId.
                     * @member {string} imageId
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.imageId = "";

                    /**
                     * Instructions cronTrigger.
                     * @member {string} cronTrigger
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.cronTrigger = "";

                    /**
                     * Instructions retryNum.
                     * @member {number} retryNum
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.retryNum = 0;

                    /**
                     * Instructions execMode.
                     * @member {string} execMode
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.execMode = "";

                    /**
                     * Instructions name.
                     * @member {string} name
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.name = "";

                    /**
                     * Instructions enabled.
                     * @member {boolean} enabled
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     */
                    Instructions.prototype.enabled = false;

                    /**
                     * Creates a new Instructions instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Instructions
                     * @static
                     * @param {cn.beepower.domain.message.IInstructions=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Instructions} Instructions instance
                     */
                    Instructions.create = function create(properties) {
                        return new Instructions(properties);
                    };

                    /**
                     * Encodes the specified Instructions message. Does not implicitly {@link cn.beepower.domain.message.Instructions.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Instructions
                     * @static
                     * @param {cn.beepower.domain.message.IInstructions} message Instructions message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Instructions.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.topic != null && Object.hasOwnProperty.call(message, "topic"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.topic);
                        if (message.commands != null && message.commands.length)
                            for (var i = 0; i < message.commands.length; ++i)
                                $root.cn.beepower.domain.message.Command.encode(message.commands[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.delayInMillis != null && message.delayInMillis.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.delayInMillis.length; ++i)
                                writer.int32(message.delayInMillis[i]);
                            writer.ldelim();
                        }
                        if (message.imageId != null && Object.hasOwnProperty.call(message, "imageId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.imageId);
                        if (message.cronTrigger != null && Object.hasOwnProperty.call(message, "cronTrigger"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.cronTrigger);
                        if (message.retryNum != null && Object.hasOwnProperty.call(message, "retryNum"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.retryNum);
                        if (message.execMode != null && Object.hasOwnProperty.call(message, "execMode"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.execMode);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.name);
                        if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.enabled);
                        return writer;
                    };

                    /**
                     * Encodes the specified Instructions message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Instructions.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Instructions
                     * @static
                     * @param {cn.beepower.domain.message.IInstructions} message Instructions message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Instructions.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Instructions message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Instructions
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Instructions} Instructions
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Instructions.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Instructions();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.topic = reader.string();
                                break;
                            case 2:
                                if (!(message.commands && message.commands.length))
                                    message.commands = [];
                                message.commands.push($root.cn.beepower.domain.message.Command.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.delayInMillis && message.delayInMillis.length))
                                    message.delayInMillis = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.delayInMillis.push(reader.int32());
                                } else
                                    message.delayInMillis.push(reader.int32());
                                break;
                            case 4:
                                message.imageId = reader.string();
                                break;
                            case 9:
                                message.cronTrigger = reader.string();
                                break;
                            case 11:
                                message.retryNum = reader.int32();
                                break;
                            case 12:
                                message.execMode = reader.string();
                                break;
                            case 14:
                                message.name = reader.string();
                                break;
                            case 15:
                                message.enabled = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Instructions message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Instructions
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Instructions} Instructions
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Instructions.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Instructions message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Instructions
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Instructions.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.topic != null && message.hasOwnProperty("topic"))
                            if (!$util.isString(message.topic))
                                return "topic: string expected";
                        if (message.commands != null && message.hasOwnProperty("commands")) {
                            if (!Array.isArray(message.commands))
                                return "commands: array expected";
                            for (var i = 0; i < message.commands.length; ++i) {
                                var error = $root.cn.beepower.domain.message.Command.verify(message.commands[i]);
                                if (error)
                                    return "commands." + error;
                            }
                        }
                        if (message.delayInMillis != null && message.hasOwnProperty("delayInMillis")) {
                            if (!Array.isArray(message.delayInMillis))
                                return "delayInMillis: array expected";
                            for (var i = 0; i < message.delayInMillis.length; ++i)
                                if (!$util.isInteger(message.delayInMillis[i]))
                                    return "delayInMillis: integer[] expected";
                        }
                        if (message.imageId != null && message.hasOwnProperty("imageId"))
                            if (!$util.isString(message.imageId))
                                return "imageId: string expected";
                        if (message.cronTrigger != null && message.hasOwnProperty("cronTrigger"))
                            if (!$util.isString(message.cronTrigger))
                                return "cronTrigger: string expected";
                        if (message.retryNum != null && message.hasOwnProperty("retryNum"))
                            if (!$util.isInteger(message.retryNum))
                                return "retryNum: integer expected";
                        if (message.execMode != null && message.hasOwnProperty("execMode"))
                            if (!$util.isString(message.execMode))
                                return "execMode: string expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.enabled != null && message.hasOwnProperty("enabled"))
                            if (typeof message.enabled !== "boolean")
                                return "enabled: boolean expected";
                        return null;
                    };

                    /**
                     * Creates an Instructions message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Instructions
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Instructions} Instructions
                     */
                    Instructions.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Instructions)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Instructions();
                        if (object.topic != null)
                            message.topic = String(object.topic);
                        if (object.commands) {
                            if (!Array.isArray(object.commands))
                                throw TypeError(".cn.beepower.domain.message.Instructions.commands: array expected");
                            message.commands = [];
                            for (var i = 0; i < object.commands.length; ++i) {
                                if (typeof object.commands[i] !== "object")
                                    throw TypeError(".cn.beepower.domain.message.Instructions.commands: object expected");
                                message.commands[i] = $root.cn.beepower.domain.message.Command.fromObject(object.commands[i]);
                            }
                        }
                        if (object.delayInMillis) {
                            if (!Array.isArray(object.delayInMillis))
                                throw TypeError(".cn.beepower.domain.message.Instructions.delayInMillis: array expected");
                            message.delayInMillis = [];
                            for (var i = 0; i < object.delayInMillis.length; ++i)
                                message.delayInMillis[i] = object.delayInMillis[i] | 0;
                        }
                        if (object.imageId != null)
                            message.imageId = String(object.imageId);
                        if (object.cronTrigger != null)
                            message.cronTrigger = String(object.cronTrigger);
                        if (object.retryNum != null)
                            message.retryNum = object.retryNum | 0;
                        if (object.execMode != null)
                            message.execMode = String(object.execMode);
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.enabled != null)
                            message.enabled = Boolean(object.enabled);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Instructions message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Instructions
                     * @static
                     * @param {cn.beepower.domain.message.Instructions} message Instructions
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Instructions.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.commands = [];
                            object.delayInMillis = [];
                        }
                        if (options.defaults) {
                            object.topic = "";
                            object.imageId = "";
                            object.cronTrigger = "";
                            object.retryNum = 0;
                            object.execMode = "";
                            object.name = "";
                            object.enabled = false;
                        }
                        if (message.topic != null && message.hasOwnProperty("topic"))
                            object.topic = message.topic;
                        if (message.commands && message.commands.length) {
                            object.commands = [];
                            for (var j = 0; j < message.commands.length; ++j)
                                object.commands[j] = $root.cn.beepower.domain.message.Command.toObject(message.commands[j], options);
                        }
                        if (message.delayInMillis && message.delayInMillis.length) {
                            object.delayInMillis = [];
                            for (var j = 0; j < message.delayInMillis.length; ++j)
                                object.delayInMillis[j] = message.delayInMillis[j];
                        }
                        if (message.imageId != null && message.hasOwnProperty("imageId"))
                            object.imageId = message.imageId;
                        if (message.cronTrigger != null && message.hasOwnProperty("cronTrigger"))
                            object.cronTrigger = message.cronTrigger;
                        if (message.retryNum != null && message.hasOwnProperty("retryNum"))
                            object.retryNum = message.retryNum;
                        if (message.execMode != null && message.hasOwnProperty("execMode"))
                            object.execMode = message.execMode;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.enabled != null && message.hasOwnProperty("enabled"))
                            object.enabled = message.enabled;
                        return object;
                    };

                    /**
                     * Converts this Instructions to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Instructions
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Instructions.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Instructions;
                })();

                message.Index = (function() {

                    /**
                     * Properties of an Index.
                     * @memberof cn.beepower.domain.message
                     * @interface IIndex
                     * @property {string|null} [id] Index id
                     * @property {string|null} [name] Index name
                     * @property {string|null} [unit] Index unit
                     * @property {string|null} [description] Index description
                     * @property {string|null} [processMode] Index processMode
                     * @property {string|null} [cron] Index cron
                     * @property {Array.<cn.beepower.domain.message.Index.IIndexSegment>|null} [segments] Index segments
                     * @property {string|null} [upperBoundEvent] Index upperBoundEvent
                     * @property {string|null} [lowerBoundEvent] Index lowerBoundEvent
                     * @property {number|null} [upperBound] Index upperBound
                     * @property {number|null} [lowerBound] Index lowerBound
                     * @property {number|null} [minUpperDurationInSeconds] Index minUpperDurationInSeconds
                     * @property {number|null} [minLowerDurationInSeconds] Index minLowerDurationInSeconds
                     * @property {number|null} [gapInSeconds] Index gapInSeconds
                     * @property {boolean|null} [enabled] Index enabled
                     */

                    /**
                     * Constructs a new Index.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Index, 不是表示值，而是最终显示的一些描述. 重点是Id
                     * 可以作为IndexCurve 的特殊形式. 这样, 整个结构不必要有大的改动.
                     * @implements IIndex
                     * @constructor
                     * @param {cn.beepower.domain.message.IIndex=} [properties] Properties to set
                     */
                    function Index(properties) {
                        this.segments = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Index id.
                     * @member {string} id
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.id = "";

                    /**
                     * Index name.
                     * @member {string} name
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.name = "";

                    /**
                     * Index unit.
                     * @member {string} unit
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.unit = "";

                    /**
                     * Index description.
                     * @member {string} description
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.description = "";

                    /**
                     * Index processMode.
                     * @member {string} processMode
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.processMode = "";

                    /**
                     * Index cron.
                     * @member {string} cron
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.cron = "";

                    /**
                     * Index segments.
                     * @member {Array.<cn.beepower.domain.message.Index.IIndexSegment>} segments
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.segments = $util.emptyArray;

                    /**
                     * Index upperBoundEvent.
                     * @member {string} upperBoundEvent
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.upperBoundEvent = "";

                    /**
                     * Index lowerBoundEvent.
                     * @member {string} lowerBoundEvent
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.lowerBoundEvent = "";

                    /**
                     * Index upperBound.
                     * @member {number} upperBound
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.upperBound = 0;

                    /**
                     * Index lowerBound.
                     * @member {number} lowerBound
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.lowerBound = 0;

                    /**
                     * Index minUpperDurationInSeconds.
                     * @member {number} minUpperDurationInSeconds
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.minUpperDurationInSeconds = 0;

                    /**
                     * Index minLowerDurationInSeconds.
                     * @member {number} minLowerDurationInSeconds
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.minLowerDurationInSeconds = 0;

                    /**
                     * Index gapInSeconds.
                     * @member {number} gapInSeconds
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.gapInSeconds = 0;

                    /**
                     * Index enabled.
                     * @member {boolean} enabled
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     */
                    Index.prototype.enabled = false;

                    /**
                     * Creates a new Index instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Index
                     * @static
                     * @param {cn.beepower.domain.message.IIndex=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Index} Index instance
                     */
                    Index.create = function create(properties) {
                        return new Index(properties);
                    };

                    /**
                     * Encodes the specified Index message. Does not implicitly {@link cn.beepower.domain.message.Index.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Index
                     * @static
                     * @param {cn.beepower.domain.message.IIndex} message Index message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Index.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.unit);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
                        if (message.processMode != null && Object.hasOwnProperty.call(message, "processMode"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.processMode);
                        if (message.cron != null && Object.hasOwnProperty.call(message, "cron"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.cron);
                        if (message.segments != null && message.segments.length)
                            for (var i = 0; i < message.segments.length; ++i)
                                $root.cn.beepower.domain.message.Index.IndexSegment.encode(message.segments[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.upperBoundEvent != null && Object.hasOwnProperty.call(message, "upperBoundEvent"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.upperBoundEvent);
                        if (message.lowerBoundEvent != null && Object.hasOwnProperty.call(message, "lowerBoundEvent"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.lowerBoundEvent);
                        if (message.upperBound != null && Object.hasOwnProperty.call(message, "upperBound"))
                            writer.uint32(/* id 10, wireType 5 =*/85).float(message.upperBound);
                        if (message.lowerBound != null && Object.hasOwnProperty.call(message, "lowerBound"))
                            writer.uint32(/* id 11, wireType 5 =*/93).float(message.lowerBound);
                        if (message.minUpperDurationInSeconds != null && Object.hasOwnProperty.call(message, "minUpperDurationInSeconds"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.minUpperDurationInSeconds);
                        if (message.minLowerDurationInSeconds != null && Object.hasOwnProperty.call(message, "minLowerDurationInSeconds"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.minLowerDurationInSeconds);
                        if (message.gapInSeconds != null && Object.hasOwnProperty.call(message, "gapInSeconds"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.gapInSeconds);
                        if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.enabled);
                        return writer;
                    };

                    /**
                     * Encodes the specified Index message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Index.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Index
                     * @static
                     * @param {cn.beepower.domain.message.IIndex} message Index message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Index.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Index message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Index
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Index} Index
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Index.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Index();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.string();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.unit = reader.string();
                                break;
                            case 4:
                                message.description = reader.string();
                                break;
                            case 5:
                                message.processMode = reader.string();
                                break;
                            case 6:
                                message.cron = reader.string();
                                break;
                            case 7:
                                if (!(message.segments && message.segments.length))
                                    message.segments = [];
                                message.segments.push($root.cn.beepower.domain.message.Index.IndexSegment.decode(reader, reader.uint32()));
                                break;
                            case 8:
                                message.upperBoundEvent = reader.string();
                                break;
                            case 9:
                                message.lowerBoundEvent = reader.string();
                                break;
                            case 10:
                                message.upperBound = reader.float();
                                break;
                            case 11:
                                message.lowerBound = reader.float();
                                break;
                            case 12:
                                message.minUpperDurationInSeconds = reader.int32();
                                break;
                            case 13:
                                message.minLowerDurationInSeconds = reader.int32();
                                break;
                            case 14:
                                message.gapInSeconds = reader.int32();
                                break;
                            case 15:
                                message.enabled = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Index message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Index
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Index} Index
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Index.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Index message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Index
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Index.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.unit != null && message.hasOwnProperty("unit"))
                            if (!$util.isString(message.unit))
                                return "unit: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.processMode != null && message.hasOwnProperty("processMode"))
                            if (!$util.isString(message.processMode))
                                return "processMode: string expected";
                        if (message.cron != null && message.hasOwnProperty("cron"))
                            if (!$util.isString(message.cron))
                                return "cron: string expected";
                        if (message.segments != null && message.hasOwnProperty("segments")) {
                            if (!Array.isArray(message.segments))
                                return "segments: array expected";
                            for (var i = 0; i < message.segments.length; ++i) {
                                var error = $root.cn.beepower.domain.message.Index.IndexSegment.verify(message.segments[i]);
                                if (error)
                                    return "segments." + error;
                            }
                        }
                        if (message.upperBoundEvent != null && message.hasOwnProperty("upperBoundEvent"))
                            if (!$util.isString(message.upperBoundEvent))
                                return "upperBoundEvent: string expected";
                        if (message.lowerBoundEvent != null && message.hasOwnProperty("lowerBoundEvent"))
                            if (!$util.isString(message.lowerBoundEvent))
                                return "lowerBoundEvent: string expected";
                        if (message.upperBound != null && message.hasOwnProperty("upperBound"))
                            if (typeof message.upperBound !== "number")
                                return "upperBound: number expected";
                        if (message.lowerBound != null && message.hasOwnProperty("lowerBound"))
                            if (typeof message.lowerBound !== "number")
                                return "lowerBound: number expected";
                        if (message.minUpperDurationInSeconds != null && message.hasOwnProperty("minUpperDurationInSeconds"))
                            if (!$util.isInteger(message.minUpperDurationInSeconds))
                                return "minUpperDurationInSeconds: integer expected";
                        if (message.minLowerDurationInSeconds != null && message.hasOwnProperty("minLowerDurationInSeconds"))
                            if (!$util.isInteger(message.minLowerDurationInSeconds))
                                return "minLowerDurationInSeconds: integer expected";
                        if (message.gapInSeconds != null && message.hasOwnProperty("gapInSeconds"))
                            if (!$util.isInteger(message.gapInSeconds))
                                return "gapInSeconds: integer expected";
                        if (message.enabled != null && message.hasOwnProperty("enabled"))
                            if (typeof message.enabled !== "boolean")
                                return "enabled: boolean expected";
                        return null;
                    };

                    /**
                     * Creates an Index message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Index
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Index} Index
                     */
                    Index.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Index)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Index();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.unit != null)
                            message.unit = String(object.unit);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.processMode != null)
                            message.processMode = String(object.processMode);
                        if (object.cron != null)
                            message.cron = String(object.cron);
                        if (object.segments) {
                            if (!Array.isArray(object.segments))
                                throw TypeError(".cn.beepower.domain.message.Index.segments: array expected");
                            message.segments = [];
                            for (var i = 0; i < object.segments.length; ++i) {
                                if (typeof object.segments[i] !== "object")
                                    throw TypeError(".cn.beepower.domain.message.Index.segments: object expected");
                                message.segments[i] = $root.cn.beepower.domain.message.Index.IndexSegment.fromObject(object.segments[i]);
                            }
                        }
                        if (object.upperBoundEvent != null)
                            message.upperBoundEvent = String(object.upperBoundEvent);
                        if (object.lowerBoundEvent != null)
                            message.lowerBoundEvent = String(object.lowerBoundEvent);
                        if (object.upperBound != null)
                            message.upperBound = Number(object.upperBound);
                        if (object.lowerBound != null)
                            message.lowerBound = Number(object.lowerBound);
                        if (object.minUpperDurationInSeconds != null)
                            message.minUpperDurationInSeconds = object.minUpperDurationInSeconds | 0;
                        if (object.minLowerDurationInSeconds != null)
                            message.minLowerDurationInSeconds = object.minLowerDurationInSeconds | 0;
                        if (object.gapInSeconds != null)
                            message.gapInSeconds = object.gapInSeconds | 0;
                        if (object.enabled != null)
                            message.enabled = Boolean(object.enabled);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Index message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Index
                     * @static
                     * @param {cn.beepower.domain.message.Index} message Index
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Index.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.segments = [];
                        if (options.defaults) {
                            object.id = "";
                            object.name = "";
                            object.unit = "";
                            object.description = "";
                            object.processMode = "";
                            object.cron = "";
                            object.upperBoundEvent = "";
                            object.lowerBoundEvent = "";
                            object.upperBound = 0;
                            object.lowerBound = 0;
                            object.minUpperDurationInSeconds = 0;
                            object.minLowerDurationInSeconds = 0;
                            object.gapInSeconds = 0;
                            object.enabled = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.unit != null && message.hasOwnProperty("unit"))
                            object.unit = message.unit;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.processMode != null && message.hasOwnProperty("processMode"))
                            object.processMode = message.processMode;
                        if (message.cron != null && message.hasOwnProperty("cron"))
                            object.cron = message.cron;
                        if (message.segments && message.segments.length) {
                            object.segments = [];
                            for (var j = 0; j < message.segments.length; ++j)
                                object.segments[j] = $root.cn.beepower.domain.message.Index.IndexSegment.toObject(message.segments[j], options);
                        }
                        if (message.upperBoundEvent != null && message.hasOwnProperty("upperBoundEvent"))
                            object.upperBoundEvent = message.upperBoundEvent;
                        if (message.lowerBoundEvent != null && message.hasOwnProperty("lowerBoundEvent"))
                            object.lowerBoundEvent = message.lowerBoundEvent;
                        if (message.upperBound != null && message.hasOwnProperty("upperBound"))
                            object.upperBound = options.json && !isFinite(message.upperBound) ? String(message.upperBound) : message.upperBound;
                        if (message.lowerBound != null && message.hasOwnProperty("lowerBound"))
                            object.lowerBound = options.json && !isFinite(message.lowerBound) ? String(message.lowerBound) : message.lowerBound;
                        if (message.minUpperDurationInSeconds != null && message.hasOwnProperty("minUpperDurationInSeconds"))
                            object.minUpperDurationInSeconds = message.minUpperDurationInSeconds;
                        if (message.minLowerDurationInSeconds != null && message.hasOwnProperty("minLowerDurationInSeconds"))
                            object.minLowerDurationInSeconds = message.minLowerDurationInSeconds;
                        if (message.gapInSeconds != null && message.hasOwnProperty("gapInSeconds"))
                            object.gapInSeconds = message.gapInSeconds;
                        if (message.enabled != null && message.hasOwnProperty("enabled"))
                            object.enabled = message.enabled;
                        return object;
                    };

                    /**
                     * Converts this Index to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Index
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Index.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    Index.IndexSegment = (function() {

                        /**
                         * Properties of an IndexSegment.
                         * @memberof cn.beepower.domain.message.Index
                         * @interface IIndexSegment
                         * @property {number|null} [durationInSeconds] IndexSegment durationInSeconds
                         * @property {string|null} [upperBoundEvent] IndexSegment upperBoundEvent
                         * @property {string|null} [lowerBoundEvent] IndexSegment lowerBoundEvent
                         * @property {number|null} [upperBound] IndexSegment upperBound
                         * @property {number|null} [lowerBound] IndexSegment lowerBound
                         */

                        /**
                         * Constructs a new IndexSegment.
                         * @memberof cn.beepower.domain.message.Index
                         * @classdesc Represents an IndexSegment.
                         * @implements IIndexSegment
                         * @constructor
                         * @param {cn.beepower.domain.message.Index.IIndexSegment=} [properties] Properties to set
                         */
                        function IndexSegment(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * IndexSegment durationInSeconds.
                         * @member {number} durationInSeconds
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @instance
                         */
                        IndexSegment.prototype.durationInSeconds = 0;

                        /**
                         * IndexSegment upperBoundEvent.
                         * @member {string} upperBoundEvent
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @instance
                         */
                        IndexSegment.prototype.upperBoundEvent = "";

                        /**
                         * IndexSegment lowerBoundEvent.
                         * @member {string} lowerBoundEvent
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @instance
                         */
                        IndexSegment.prototype.lowerBoundEvent = "";

                        /**
                         * IndexSegment upperBound.
                         * @member {number} upperBound
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @instance
                         */
                        IndexSegment.prototype.upperBound = 0;

                        /**
                         * IndexSegment lowerBound.
                         * @member {number} lowerBound
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @instance
                         */
                        IndexSegment.prototype.lowerBound = 0;

                        /**
                         * Creates a new IndexSegment instance using the specified properties.
                         * @function create
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @static
                         * @param {cn.beepower.domain.message.Index.IIndexSegment=} [properties] Properties to set
                         * @returns {cn.beepower.domain.message.Index.IndexSegment} IndexSegment instance
                         */
                        IndexSegment.create = function create(properties) {
                            return new IndexSegment(properties);
                        };

                        /**
                         * Encodes the specified IndexSegment message. Does not implicitly {@link cn.beepower.domain.message.Index.IndexSegment.verify|verify} messages.
                         * @function encode
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @static
                         * @param {cn.beepower.domain.message.Index.IIndexSegment} message IndexSegment message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        IndexSegment.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.durationInSeconds != null && Object.hasOwnProperty.call(message, "durationInSeconds"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.durationInSeconds);
                            if (message.upperBoundEvent != null && Object.hasOwnProperty.call(message, "upperBoundEvent"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.upperBoundEvent);
                            if (message.lowerBoundEvent != null && Object.hasOwnProperty.call(message, "lowerBoundEvent"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.lowerBoundEvent);
                            if (message.upperBound != null && Object.hasOwnProperty.call(message, "upperBound"))
                                writer.uint32(/* id 7, wireType 5 =*/61).float(message.upperBound);
                            if (message.lowerBound != null && Object.hasOwnProperty.call(message, "lowerBound"))
                                writer.uint32(/* id 8, wireType 5 =*/69).float(message.lowerBound);
                            return writer;
                        };

                        /**
                         * Encodes the specified IndexSegment message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Index.IndexSegment.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @static
                         * @param {cn.beepower.domain.message.Index.IIndexSegment} message IndexSegment message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        IndexSegment.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an IndexSegment message from the specified reader or buffer.
                         * @function decode
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {cn.beepower.domain.message.Index.IndexSegment} IndexSegment
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        IndexSegment.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Index.IndexSegment();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.durationInSeconds = reader.int32();
                                    break;
                                case 5:
                                    message.upperBoundEvent = reader.string();
                                    break;
                                case 6:
                                    message.lowerBoundEvent = reader.string();
                                    break;
                                case 7:
                                    message.upperBound = reader.float();
                                    break;
                                case 8:
                                    message.lowerBound = reader.float();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an IndexSegment message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {cn.beepower.domain.message.Index.IndexSegment} IndexSegment
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        IndexSegment.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an IndexSegment message.
                         * @function verify
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        IndexSegment.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.durationInSeconds != null && message.hasOwnProperty("durationInSeconds"))
                                if (!$util.isInteger(message.durationInSeconds))
                                    return "durationInSeconds: integer expected";
                            if (message.upperBoundEvent != null && message.hasOwnProperty("upperBoundEvent"))
                                if (!$util.isString(message.upperBoundEvent))
                                    return "upperBoundEvent: string expected";
                            if (message.lowerBoundEvent != null && message.hasOwnProperty("lowerBoundEvent"))
                                if (!$util.isString(message.lowerBoundEvent))
                                    return "lowerBoundEvent: string expected";
                            if (message.upperBound != null && message.hasOwnProperty("upperBound"))
                                if (typeof message.upperBound !== "number")
                                    return "upperBound: number expected";
                            if (message.lowerBound != null && message.hasOwnProperty("lowerBound"))
                                if (typeof message.lowerBound !== "number")
                                    return "lowerBound: number expected";
                            return null;
                        };

                        /**
                         * Creates an IndexSegment message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {cn.beepower.domain.message.Index.IndexSegment} IndexSegment
                         */
                        IndexSegment.fromObject = function fromObject(object) {
                            if (object instanceof $root.cn.beepower.domain.message.Index.IndexSegment)
                                return object;
                            var message = new $root.cn.beepower.domain.message.Index.IndexSegment();
                            if (object.durationInSeconds != null)
                                message.durationInSeconds = object.durationInSeconds | 0;
                            if (object.upperBoundEvent != null)
                                message.upperBoundEvent = String(object.upperBoundEvent);
                            if (object.lowerBoundEvent != null)
                                message.lowerBoundEvent = String(object.lowerBoundEvent);
                            if (object.upperBound != null)
                                message.upperBound = Number(object.upperBound);
                            if (object.lowerBound != null)
                                message.lowerBound = Number(object.lowerBound);
                            return message;
                        };

                        /**
                         * Creates a plain object from an IndexSegment message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @static
                         * @param {cn.beepower.domain.message.Index.IndexSegment} message IndexSegment
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        IndexSegment.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.durationInSeconds = 0;
                                object.upperBoundEvent = "";
                                object.lowerBoundEvent = "";
                                object.upperBound = 0;
                                object.lowerBound = 0;
                            }
                            if (message.durationInSeconds != null && message.hasOwnProperty("durationInSeconds"))
                                object.durationInSeconds = message.durationInSeconds;
                            if (message.upperBoundEvent != null && message.hasOwnProperty("upperBoundEvent"))
                                object.upperBoundEvent = message.upperBoundEvent;
                            if (message.lowerBoundEvent != null && message.hasOwnProperty("lowerBoundEvent"))
                                object.lowerBoundEvent = message.lowerBoundEvent;
                            if (message.upperBound != null && message.hasOwnProperty("upperBound"))
                                object.upperBound = options.json && !isFinite(message.upperBound) ? String(message.upperBound) : message.upperBound;
                            if (message.lowerBound != null && message.hasOwnProperty("lowerBound"))
                                object.lowerBound = options.json && !isFinite(message.lowerBound) ? String(message.lowerBound) : message.lowerBound;
                            return object;
                        };

                        /**
                         * Converts this IndexSegment to JSON.
                         * @function toJSON
                         * @memberof cn.beepower.domain.message.Index.IndexSegment
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        IndexSegment.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        return IndexSegment;
                    })();

                    return Index;
                })();

                message.Holidays = (function() {

                    /**
                     * Properties of a Holidays.
                     * @memberof cn.beepower.domain.message
                     * @interface IHolidays
                     * @property {number|null} [year] Holidays year
                     * @property {Array.<string>|null} [holiday] Holidays holiday
                     * @property {string|null} [countryCode] Holidays countryCode
                     */

                    /**
                     * Constructs a new Holidays.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a Holidays.
                     * @implements IHolidays
                     * @constructor
                     * @param {cn.beepower.domain.message.IHolidays=} [properties] Properties to set
                     */
                    function Holidays(properties) {
                        this.holiday = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Holidays year.
                     * @member {number} year
                     * @memberof cn.beepower.domain.message.Holidays
                     * @instance
                     */
                    Holidays.prototype.year = 0;

                    /**
                     * Holidays holiday.
                     * @member {Array.<string>} holiday
                     * @memberof cn.beepower.domain.message.Holidays
                     * @instance
                     */
                    Holidays.prototype.holiday = $util.emptyArray;

                    /**
                     * Holidays countryCode.
                     * @member {string} countryCode
                     * @memberof cn.beepower.domain.message.Holidays
                     * @instance
                     */
                    Holidays.prototype.countryCode = "";

                    /**
                     * Creates a new Holidays instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Holidays
                     * @static
                     * @param {cn.beepower.domain.message.IHolidays=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Holidays} Holidays instance
                     */
                    Holidays.create = function create(properties) {
                        return new Holidays(properties);
                    };

                    /**
                     * Encodes the specified Holidays message. Does not implicitly {@link cn.beepower.domain.message.Holidays.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Holidays
                     * @static
                     * @param {cn.beepower.domain.message.IHolidays} message Holidays message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Holidays.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                        if (message.holiday != null && message.holiday.length)
                            for (var i = 0; i < message.holiday.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.holiday[i]);
                        if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.countryCode);
                        return writer;
                    };

                    /**
                     * Encodes the specified Holidays message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Holidays.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Holidays
                     * @static
                     * @param {cn.beepower.domain.message.IHolidays} message Holidays message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Holidays.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Holidays message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Holidays
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Holidays} Holidays
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Holidays.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Holidays();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.year = reader.int32();
                                break;
                            case 2:
                                if (!(message.holiday && message.holiday.length))
                                    message.holiday = [];
                                message.holiday.push(reader.string());
                                break;
                            case 5:
                                message.countryCode = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Holidays message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Holidays
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Holidays} Holidays
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Holidays.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Holidays message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Holidays
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Holidays.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.year != null && message.hasOwnProperty("year"))
                            if (!$util.isInteger(message.year))
                                return "year: integer expected";
                        if (message.holiday != null && message.hasOwnProperty("holiday")) {
                            if (!Array.isArray(message.holiday))
                                return "holiday: array expected";
                            for (var i = 0; i < message.holiday.length; ++i)
                                if (!$util.isString(message.holiday[i]))
                                    return "holiday: string[] expected";
                        }
                        if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                            if (!$util.isString(message.countryCode))
                                return "countryCode: string expected";
                        return null;
                    };

                    /**
                     * Creates a Holidays message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Holidays
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Holidays} Holidays
                     */
                    Holidays.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Holidays)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Holidays();
                        if (object.year != null)
                            message.year = object.year | 0;
                        if (object.holiday) {
                            if (!Array.isArray(object.holiday))
                                throw TypeError(".cn.beepower.domain.message.Holidays.holiday: array expected");
                            message.holiday = [];
                            for (var i = 0; i < object.holiday.length; ++i)
                                message.holiday[i] = String(object.holiday[i]);
                        }
                        if (object.countryCode != null)
                            message.countryCode = String(object.countryCode);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Holidays message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Holidays
                     * @static
                     * @param {cn.beepower.domain.message.Holidays} message Holidays
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Holidays.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.holiday = [];
                        if (options.defaults) {
                            object.year = 0;
                            object.countryCode = "";
                        }
                        if (message.year != null && message.hasOwnProperty("year"))
                            object.year = message.year;
                        if (message.holiday && message.holiday.length) {
                            object.holiday = [];
                            for (var j = 0; j < message.holiday.length; ++j)
                                object.holiday[j] = message.holiday[j];
                        }
                        if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                            object.countryCode = message.countryCode;
                        return object;
                    };

                    /**
                     * Converts this Holidays to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Holidays
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Holidays.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Holidays;
                })();

                message.Thing = (function() {

                    /**
                     * Properties of a Thing.
                     * @memberof cn.beepower.domain.message
                     * @interface IThing
                     * @property {string|null} [id] Thing id
                     * @property {string|null} [alias] Thing alias
                     * @property {string|null} [name] Thing name
                     * @property {string|null} [clazz] Thing clazz
                     * @property {string|null} [remark] Thing remark
                     * @property {Array.<string>|null} [tags] Thing tags
                     * @property {Array.<string>|null} [attributes] Thing attributes
                     * @property {string|null} [extraText] Thing extraText
                     * @property {Uint8Array|null} [extraData] Thing extraData
                     * @property {string|null} [location] Thing location
                     * @property {boolean|null} [isVirtual] Thing isVirtual
                     * @property {string|null} [gpsPosition] Thing gpsPosition
                     * @property {number|null} [version] Thing version
                     * @property {string|null} [photoUrl] Thing photoUrl
                     * @property {string|null} [master] Thing master
                     * @property {string|null} [iid] Thing iid
                     */

                    /**
                     * Constructs a new Thing.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a Thing.
                     * @implements IThing
                     * @constructor
                     * @param {cn.beepower.domain.message.IThing=} [properties] Properties to set
                     */
                    function Thing(properties) {
                        this.tags = [];
                        this.attributes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Thing id.
                     * @member {string} id
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.id = "";

                    /**
                     * Thing alias.
                     * @member {string} alias
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.alias = "";

                    /**
                     * Thing name.
                     * @member {string} name
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.name = "";

                    /**
                     * Thing clazz.
                     * @member {string} clazz
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.clazz = "";

                    /**
                     * Thing remark.
                     * @member {string} remark
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.remark = "";

                    /**
                     * Thing tags.
                     * @member {Array.<string>} tags
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.tags = $util.emptyArray;

                    /**
                     * Thing attributes.
                     * @member {Array.<string>} attributes
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.attributes = $util.emptyArray;

                    /**
                     * Thing extraText.
                     * @member {string} extraText
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.extraText = "";

                    /**
                     * Thing extraData.
                     * @member {Uint8Array} extraData
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.extraData = $util.newBuffer([]);

                    /**
                     * Thing location.
                     * @member {string} location
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.location = "";

                    /**
                     * Thing isVirtual.
                     * @member {boolean} isVirtual
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.isVirtual = false;

                    /**
                     * Thing gpsPosition.
                     * @member {string} gpsPosition
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.gpsPosition = "";

                    /**
                     * Thing version.
                     * @member {number} version
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.version = 0;

                    /**
                     * Thing photoUrl.
                     * @member {string} photoUrl
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.photoUrl = "";

                    /**
                     * Thing master.
                     * @member {string} master
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.master = "";

                    /**
                     * Thing iid.
                     * @member {string} iid
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     */
                    Thing.prototype.iid = "";

                    /**
                     * Creates a new Thing instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Thing
                     * @static
                     * @param {cn.beepower.domain.message.IThing=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Thing} Thing instance
                     */
                    Thing.create = function create(properties) {
                        return new Thing(properties);
                    };

                    /**
                     * Encodes the specified Thing message. Does not implicitly {@link cn.beepower.domain.message.Thing.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Thing
                     * @static
                     * @param {cn.beepower.domain.message.IThing} message Thing message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Thing.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.alias != null && Object.hasOwnProperty.call(message, "alias"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.alias);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.clazz != null && Object.hasOwnProperty.call(message, "clazz"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.clazz);
                        if (message.remark != null && Object.hasOwnProperty.call(message, "remark"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.remark);
                        if (message.tags != null && message.tags.length)
                            for (var i = 0; i < message.tags.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.tags[i]);
                        if (message.attributes != null && message.attributes.length)
                            for (var i = 0; i < message.attributes.length; ++i)
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.attributes[i]);
                        if (message.extraText != null && Object.hasOwnProperty.call(message, "extraText"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.extraText);
                        if (message.extraData != null && Object.hasOwnProperty.call(message, "extraData"))
                            writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.extraData);
                        if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.location);
                        if (message.isVirtual != null && Object.hasOwnProperty.call(message, "isVirtual"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isVirtual);
                        if (message.gpsPosition != null && Object.hasOwnProperty.call(message, "gpsPosition"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.gpsPosition);
                        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.version);
                        if (message.photoUrl != null && Object.hasOwnProperty.call(message, "photoUrl"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.photoUrl);
                        if (message.master != null && Object.hasOwnProperty.call(message, "master"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.master);
                        if (message.iid != null && Object.hasOwnProperty.call(message, "iid"))
                            writer.uint32(/* id 16, wireType 2 =*/130).string(message.iid);
                        return writer;
                    };

                    /**
                     * Encodes the specified Thing message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Thing.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Thing
                     * @static
                     * @param {cn.beepower.domain.message.IThing} message Thing message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Thing.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Thing message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Thing
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Thing} Thing
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Thing.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Thing();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.string();
                                break;
                            case 2:
                                message.alias = reader.string();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.clazz = reader.string();
                                break;
                            case 5:
                                message.remark = reader.string();
                                break;
                            case 6:
                                if (!(message.tags && message.tags.length))
                                    message.tags = [];
                                message.tags.push(reader.string());
                                break;
                            case 7:
                                if (!(message.attributes && message.attributes.length))
                                    message.attributes = [];
                                message.attributes.push(reader.string());
                                break;
                            case 8:
                                message.extraText = reader.string();
                                break;
                            case 9:
                                message.extraData = reader.bytes();
                                break;
                            case 10:
                                message.location = reader.string();
                                break;
                            case 11:
                                message.isVirtual = reader.bool();
                                break;
                            case 12:
                                message.gpsPosition = reader.string();
                                break;
                            case 13:
                                message.version = reader.int32();
                                break;
                            case 14:
                                message.photoUrl = reader.string();
                                break;
                            case 15:
                                message.master = reader.string();
                                break;
                            case 16:
                                message.iid = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Thing message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Thing
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Thing} Thing
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Thing.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Thing message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Thing
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Thing.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.alias != null && message.hasOwnProperty("alias"))
                            if (!$util.isString(message.alias))
                                return "alias: string expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.clazz != null && message.hasOwnProperty("clazz"))
                            if (!$util.isString(message.clazz))
                                return "clazz: string expected";
                        if (message.remark != null && message.hasOwnProperty("remark"))
                            if (!$util.isString(message.remark))
                                return "remark: string expected";
                        if (message.tags != null && message.hasOwnProperty("tags")) {
                            if (!Array.isArray(message.tags))
                                return "tags: array expected";
                            for (var i = 0; i < message.tags.length; ++i)
                                if (!$util.isString(message.tags[i]))
                                    return "tags: string[] expected";
                        }
                        if (message.attributes != null && message.hasOwnProperty("attributes")) {
                            if (!Array.isArray(message.attributes))
                                return "attributes: array expected";
                            for (var i = 0; i < message.attributes.length; ++i)
                                if (!$util.isString(message.attributes[i]))
                                    return "attributes: string[] expected";
                        }
                        if (message.extraText != null && message.hasOwnProperty("extraText"))
                            if (!$util.isString(message.extraText))
                                return "extraText: string expected";
                        if (message.extraData != null && message.hasOwnProperty("extraData"))
                            if (!(message.extraData && typeof message.extraData.length === "number" || $util.isString(message.extraData)))
                                return "extraData: buffer expected";
                        if (message.location != null && message.hasOwnProperty("location"))
                            if (!$util.isString(message.location))
                                return "location: string expected";
                        if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                            if (typeof message.isVirtual !== "boolean")
                                return "isVirtual: boolean expected";
                        if (message.gpsPosition != null && message.hasOwnProperty("gpsPosition"))
                            if (!$util.isString(message.gpsPosition))
                                return "gpsPosition: string expected";
                        if (message.version != null && message.hasOwnProperty("version"))
                            if (!$util.isInteger(message.version))
                                return "version: integer expected";
                        if (message.photoUrl != null && message.hasOwnProperty("photoUrl"))
                            if (!$util.isString(message.photoUrl))
                                return "photoUrl: string expected";
                        if (message.master != null && message.hasOwnProperty("master"))
                            if (!$util.isString(message.master))
                                return "master: string expected";
                        if (message.iid != null && message.hasOwnProperty("iid"))
                            if (!$util.isString(message.iid))
                                return "iid: string expected";
                        return null;
                    };

                    /**
                     * Creates a Thing message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Thing
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Thing} Thing
                     */
                    Thing.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Thing)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Thing();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.alias != null)
                            message.alias = String(object.alias);
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.clazz != null)
                            message.clazz = String(object.clazz);
                        if (object.remark != null)
                            message.remark = String(object.remark);
                        if (object.tags) {
                            if (!Array.isArray(object.tags))
                                throw TypeError(".cn.beepower.domain.message.Thing.tags: array expected");
                            message.tags = [];
                            for (var i = 0; i < object.tags.length; ++i)
                                message.tags[i] = String(object.tags[i]);
                        }
                        if (object.attributes) {
                            if (!Array.isArray(object.attributes))
                                throw TypeError(".cn.beepower.domain.message.Thing.attributes: array expected");
                            message.attributes = [];
                            for (var i = 0; i < object.attributes.length; ++i)
                                message.attributes[i] = String(object.attributes[i]);
                        }
                        if (object.extraText != null)
                            message.extraText = String(object.extraText);
                        if (object.extraData != null)
                            if (typeof object.extraData === "string")
                                $util.base64.decode(object.extraData, message.extraData = $util.newBuffer($util.base64.length(object.extraData)), 0);
                            else if (object.extraData.length)
                                message.extraData = object.extraData;
                        if (object.location != null)
                            message.location = String(object.location);
                        if (object.isVirtual != null)
                            message.isVirtual = Boolean(object.isVirtual);
                        if (object.gpsPosition != null)
                            message.gpsPosition = String(object.gpsPosition);
                        if (object.version != null)
                            message.version = object.version | 0;
                        if (object.photoUrl != null)
                            message.photoUrl = String(object.photoUrl);
                        if (object.master != null)
                            message.master = String(object.master);
                        if (object.iid != null)
                            message.iid = String(object.iid);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Thing message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Thing
                     * @static
                     * @param {cn.beepower.domain.message.Thing} message Thing
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Thing.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.tags = [];
                            object.attributes = [];
                        }
                        if (options.defaults) {
                            object.id = "";
                            object.alias = "";
                            object.name = "";
                            object.clazz = "";
                            object.remark = "";
                            object.extraText = "";
                            if (options.bytes === String)
                                object.extraData = "";
                            else {
                                object.extraData = [];
                                if (options.bytes !== Array)
                                    object.extraData = $util.newBuffer(object.extraData);
                            }
                            object.location = "";
                            object.isVirtual = false;
                            object.gpsPosition = "";
                            object.version = 0;
                            object.photoUrl = "";
                            object.master = "";
                            object.iid = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.alias != null && message.hasOwnProperty("alias"))
                            object.alias = message.alias;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.clazz != null && message.hasOwnProperty("clazz"))
                            object.clazz = message.clazz;
                        if (message.remark != null && message.hasOwnProperty("remark"))
                            object.remark = message.remark;
                        if (message.tags && message.tags.length) {
                            object.tags = [];
                            for (var j = 0; j < message.tags.length; ++j)
                                object.tags[j] = message.tags[j];
                        }
                        if (message.attributes && message.attributes.length) {
                            object.attributes = [];
                            for (var j = 0; j < message.attributes.length; ++j)
                                object.attributes[j] = message.attributes[j];
                        }
                        if (message.extraText != null && message.hasOwnProperty("extraText"))
                            object.extraText = message.extraText;
                        if (message.extraData != null && message.hasOwnProperty("extraData"))
                            object.extraData = options.bytes === String ? $util.base64.encode(message.extraData, 0, message.extraData.length) : options.bytes === Array ? Array.prototype.slice.call(message.extraData) : message.extraData;
                        if (message.location != null && message.hasOwnProperty("location"))
                            object.location = message.location;
                        if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                            object.isVirtual = message.isVirtual;
                        if (message.gpsPosition != null && message.hasOwnProperty("gpsPosition"))
                            object.gpsPosition = message.gpsPosition;
                        if (message.version != null && message.hasOwnProperty("version"))
                            object.version = message.version;
                        if (message.photoUrl != null && message.hasOwnProperty("photoUrl"))
                            object.photoUrl = message.photoUrl;
                        if (message.master != null && message.hasOwnProperty("master"))
                            object.master = message.master;
                        if (message.iid != null && message.hasOwnProperty("iid"))
                            object.iid = message.iid;
                        return object;
                    };

                    /**
                     * Converts this Thing to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Thing
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Thing.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Thing;
                })();

                message.Ambient = (function() {

                    /**
                     * Properties of an Ambient.
                     * @memberof cn.beepower.domain.message
                     * @interface IAmbient
                     * @property {cn.beepower.domain.message.IThing|null} [t] Ambient t
                     * @property {string|null} [aggregates] Ambient aggregates
                     * @property {string|null} [industry] Ambient industry
                     * @property {string|null} [countryCode] Ambient countryCode
                     * @property {Array.<cn.beepower.domain.message.Ambient.IRoom>|null} [rooms] Ambient rooms
                     * @property {string|null} [timeZone] Ambient timeZone
                     * @property {string|null} [ssid] Ambient ssid
                     */

                    /**
                     * Constructs a new Ambient.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents an Ambient.
                     * @implements IAmbient
                     * @constructor
                     * @param {cn.beepower.domain.message.IAmbient=} [properties] Properties to set
                     */
                    function Ambient(properties) {
                        this.rooms = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Ambient t.
                     * @member {cn.beepower.domain.message.IThing|null|undefined} t
                     * @memberof cn.beepower.domain.message.Ambient
                     * @instance
                     */
                    Ambient.prototype.t = null;

                    /**
                     * Ambient aggregates.
                     * @member {string} aggregates
                     * @memberof cn.beepower.domain.message.Ambient
                     * @instance
                     */
                    Ambient.prototype.aggregates = "";

                    /**
                     * Ambient industry.
                     * @member {string} industry
                     * @memberof cn.beepower.domain.message.Ambient
                     * @instance
                     */
                    Ambient.prototype.industry = "";

                    /**
                     * Ambient countryCode.
                     * @member {string} countryCode
                     * @memberof cn.beepower.domain.message.Ambient
                     * @instance
                     */
                    Ambient.prototype.countryCode = "";

                    /**
                     * Ambient rooms.
                     * @member {Array.<cn.beepower.domain.message.Ambient.IRoom>} rooms
                     * @memberof cn.beepower.domain.message.Ambient
                     * @instance
                     */
                    Ambient.prototype.rooms = $util.emptyArray;

                    /**
                     * Ambient timeZone.
                     * @member {string} timeZone
                     * @memberof cn.beepower.domain.message.Ambient
                     * @instance
                     */
                    Ambient.prototype.timeZone = "";

                    /**
                     * Ambient ssid.
                     * @member {string} ssid
                     * @memberof cn.beepower.domain.message.Ambient
                     * @instance
                     */
                    Ambient.prototype.ssid = "";

                    /**
                     * Creates a new Ambient instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Ambient
                     * @static
                     * @param {cn.beepower.domain.message.IAmbient=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Ambient} Ambient instance
                     */
                    Ambient.create = function create(properties) {
                        return new Ambient(properties);
                    };

                    /**
                     * Encodes the specified Ambient message. Does not implicitly {@link cn.beepower.domain.message.Ambient.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Ambient
                     * @static
                     * @param {cn.beepower.domain.message.IAmbient} message Ambient message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Ambient.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.t != null && Object.hasOwnProperty.call(message, "t"))
                            $root.cn.beepower.domain.message.Thing.encode(message.t, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.aggregates != null && Object.hasOwnProperty.call(message, "aggregates"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.aggregates);
                        if (message.industry != null && Object.hasOwnProperty.call(message, "industry"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.industry);
                        if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.countryCode);
                        if (message.rooms != null && message.rooms.length)
                            for (var i = 0; i < message.rooms.length; ++i)
                                $root.cn.beepower.domain.message.Ambient.Room.encode(message.rooms[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.timeZone);
                        if (message.ssid != null && Object.hasOwnProperty.call(message, "ssid"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.ssid);
                        return writer;
                    };

                    /**
                     * Encodes the specified Ambient message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Ambient.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Ambient
                     * @static
                     * @param {cn.beepower.domain.message.IAmbient} message Ambient message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Ambient.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Ambient message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Ambient
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Ambient} Ambient
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Ambient.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Ambient();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.t = $root.cn.beepower.domain.message.Thing.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.aggregates = reader.string();
                                break;
                            case 4:
                                message.industry = reader.string();
                                break;
                            case 5:
                                message.countryCode = reader.string();
                                break;
                            case 6:
                                if (!(message.rooms && message.rooms.length))
                                    message.rooms = [];
                                message.rooms.push($root.cn.beepower.domain.message.Ambient.Room.decode(reader, reader.uint32()));
                                break;
                            case 10:
                                message.timeZone = reader.string();
                                break;
                            case 11:
                                message.ssid = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Ambient message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Ambient
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Ambient} Ambient
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Ambient.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Ambient message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Ambient
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Ambient.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.t != null && message.hasOwnProperty("t")) {
                            var error = $root.cn.beepower.domain.message.Thing.verify(message.t);
                            if (error)
                                return "t." + error;
                        }
                        if (message.aggregates != null && message.hasOwnProperty("aggregates"))
                            if (!$util.isString(message.aggregates))
                                return "aggregates: string expected";
                        if (message.industry != null && message.hasOwnProperty("industry"))
                            if (!$util.isString(message.industry))
                                return "industry: string expected";
                        if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                            if (!$util.isString(message.countryCode))
                                return "countryCode: string expected";
                        if (message.rooms != null && message.hasOwnProperty("rooms")) {
                            if (!Array.isArray(message.rooms))
                                return "rooms: array expected";
                            for (var i = 0; i < message.rooms.length; ++i) {
                                var error = $root.cn.beepower.domain.message.Ambient.Room.verify(message.rooms[i]);
                                if (error)
                                    return "rooms." + error;
                            }
                        }
                        if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                            if (!$util.isString(message.timeZone))
                                return "timeZone: string expected";
                        if (message.ssid != null && message.hasOwnProperty("ssid"))
                            if (!$util.isString(message.ssid))
                                return "ssid: string expected";
                        return null;
                    };

                    /**
                     * Creates an Ambient message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Ambient
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Ambient} Ambient
                     */
                    Ambient.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Ambient)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Ambient();
                        if (object.t != null) {
                            if (typeof object.t !== "object")
                                throw TypeError(".cn.beepower.domain.message.Ambient.t: object expected");
                            message.t = $root.cn.beepower.domain.message.Thing.fromObject(object.t);
                        }
                        if (object.aggregates != null)
                            message.aggregates = String(object.aggregates);
                        if (object.industry != null)
                            message.industry = String(object.industry);
                        if (object.countryCode != null)
                            message.countryCode = String(object.countryCode);
                        if (object.rooms) {
                            if (!Array.isArray(object.rooms))
                                throw TypeError(".cn.beepower.domain.message.Ambient.rooms: array expected");
                            message.rooms = [];
                            for (var i = 0; i < object.rooms.length; ++i) {
                                if (typeof object.rooms[i] !== "object")
                                    throw TypeError(".cn.beepower.domain.message.Ambient.rooms: object expected");
                                message.rooms[i] = $root.cn.beepower.domain.message.Ambient.Room.fromObject(object.rooms[i]);
                            }
                        }
                        if (object.timeZone != null)
                            message.timeZone = String(object.timeZone);
                        if (object.ssid != null)
                            message.ssid = String(object.ssid);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Ambient message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Ambient
                     * @static
                     * @param {cn.beepower.domain.message.Ambient} message Ambient
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Ambient.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rooms = [];
                        if (options.defaults) {
                            object.t = null;
                            object.aggregates = "";
                            object.industry = "";
                            object.countryCode = "";
                            object.timeZone = "";
                            object.ssid = "";
                        }
                        if (message.t != null && message.hasOwnProperty("t"))
                            object.t = $root.cn.beepower.domain.message.Thing.toObject(message.t, options);
                        if (message.aggregates != null && message.hasOwnProperty("aggregates"))
                            object.aggregates = message.aggregates;
                        if (message.industry != null && message.hasOwnProperty("industry"))
                            object.industry = message.industry;
                        if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                            object.countryCode = message.countryCode;
                        if (message.rooms && message.rooms.length) {
                            object.rooms = [];
                            for (var j = 0; j < message.rooms.length; ++j)
                                object.rooms[j] = $root.cn.beepower.domain.message.Ambient.Room.toObject(message.rooms[j], options);
                        }
                        if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                            object.timeZone = message.timeZone;
                        if (message.ssid != null && message.hasOwnProperty("ssid"))
                            object.ssid = message.ssid;
                        return object;
                    };

                    /**
                     * Converts this Ambient to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Ambient
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Ambient.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    Ambient.Room = (function() {

                        /**
                         * Properties of a Room.
                         * @memberof cn.beepower.domain.message.Ambient
                         * @interface IRoom
                         * @property {cn.beepower.domain.message.IThing|null} [t] Room t
                         * @property {string|null} [aggregates] Room aggregates
                         * @property {Array.<cn.beepower.domain.message.IThing>|null} [terminals] Room terminals
                         */

                        /**
                         * Constructs a new Room.
                         * @memberof cn.beepower.domain.message.Ambient
                         * @classdesc Represents a Room.
                         * @implements IRoom
                         * @constructor
                         * @param {cn.beepower.domain.message.Ambient.IRoom=} [properties] Properties to set
                         */
                        function Room(properties) {
                            this.terminals = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Room t.
                         * @member {cn.beepower.domain.message.IThing|null|undefined} t
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @instance
                         */
                        Room.prototype.t = null;

                        /**
                         * Room aggregates.
                         * @member {string} aggregates
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @instance
                         */
                        Room.prototype.aggregates = "";

                        /**
                         * Room terminals.
                         * @member {Array.<cn.beepower.domain.message.IThing>} terminals
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @instance
                         */
                        Room.prototype.terminals = $util.emptyArray;

                        /**
                         * Creates a new Room instance using the specified properties.
                         * @function create
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @static
                         * @param {cn.beepower.domain.message.Ambient.IRoom=} [properties] Properties to set
                         * @returns {cn.beepower.domain.message.Ambient.Room} Room instance
                         */
                        Room.create = function create(properties) {
                            return new Room(properties);
                        };

                        /**
                         * Encodes the specified Room message. Does not implicitly {@link cn.beepower.domain.message.Ambient.Room.verify|verify} messages.
                         * @function encode
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @static
                         * @param {cn.beepower.domain.message.Ambient.IRoom} message Room message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Room.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.t != null && Object.hasOwnProperty.call(message, "t"))
                                $root.cn.beepower.domain.message.Thing.encode(message.t, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.aggregates != null && Object.hasOwnProperty.call(message, "aggregates"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.aggregates);
                            if (message.terminals != null && message.terminals.length)
                                for (var i = 0; i < message.terminals.length; ++i)
                                    $root.cn.beepower.domain.message.Thing.encode(message.terminals[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified Room message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Ambient.Room.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @static
                         * @param {cn.beepower.domain.message.Ambient.IRoom} message Room message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Room.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Room message from the specified reader or buffer.
                         * @function decode
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {cn.beepower.domain.message.Ambient.Room} Room
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Room.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Ambient.Room();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.t = $root.cn.beepower.domain.message.Thing.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.aggregates = reader.string();
                                    break;
                                case 5:
                                    if (!(message.terminals && message.terminals.length))
                                        message.terminals = [];
                                    message.terminals.push($root.cn.beepower.domain.message.Thing.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Room message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {cn.beepower.domain.message.Ambient.Room} Room
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Room.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Room message.
                         * @function verify
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Room.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.t != null && message.hasOwnProperty("t")) {
                                var error = $root.cn.beepower.domain.message.Thing.verify(message.t);
                                if (error)
                                    return "t." + error;
                            }
                            if (message.aggregates != null && message.hasOwnProperty("aggregates"))
                                if (!$util.isString(message.aggregates))
                                    return "aggregates: string expected";
                            if (message.terminals != null && message.hasOwnProperty("terminals")) {
                                if (!Array.isArray(message.terminals))
                                    return "terminals: array expected";
                                for (var i = 0; i < message.terminals.length; ++i) {
                                    var error = $root.cn.beepower.domain.message.Thing.verify(message.terminals[i]);
                                    if (error)
                                        return "terminals." + error;
                                }
                            }
                            return null;
                        };

                        /**
                         * Creates a Room message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {cn.beepower.domain.message.Ambient.Room} Room
                         */
                        Room.fromObject = function fromObject(object) {
                            if (object instanceof $root.cn.beepower.domain.message.Ambient.Room)
                                return object;
                            var message = new $root.cn.beepower.domain.message.Ambient.Room();
                            if (object.t != null) {
                                if (typeof object.t !== "object")
                                    throw TypeError(".cn.beepower.domain.message.Ambient.Room.t: object expected");
                                message.t = $root.cn.beepower.domain.message.Thing.fromObject(object.t);
                            }
                            if (object.aggregates != null)
                                message.aggregates = String(object.aggregates);
                            if (object.terminals) {
                                if (!Array.isArray(object.terminals))
                                    throw TypeError(".cn.beepower.domain.message.Ambient.Room.terminals: array expected");
                                message.terminals = [];
                                for (var i = 0; i < object.terminals.length; ++i) {
                                    if (typeof object.terminals[i] !== "object")
                                        throw TypeError(".cn.beepower.domain.message.Ambient.Room.terminals: object expected");
                                    message.terminals[i] = $root.cn.beepower.domain.message.Thing.fromObject(object.terminals[i]);
                                }
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from a Room message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @static
                         * @param {cn.beepower.domain.message.Ambient.Room} message Room
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Room.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.terminals = [];
                            if (options.defaults) {
                                object.t = null;
                                object.aggregates = "";
                            }
                            if (message.t != null && message.hasOwnProperty("t"))
                                object.t = $root.cn.beepower.domain.message.Thing.toObject(message.t, options);
                            if (message.aggregates != null && message.hasOwnProperty("aggregates"))
                                object.aggregates = message.aggregates;
                            if (message.terminals && message.terminals.length) {
                                object.terminals = [];
                                for (var j = 0; j < message.terminals.length; ++j)
                                    object.terminals[j] = $root.cn.beepower.domain.message.Thing.toObject(message.terminals[j], options);
                            }
                            return object;
                        };

                        /**
                         * Converts this Room to JSON.
                         * @function toJSON
                         * @memberof cn.beepower.domain.message.Ambient.Room
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Room.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        return Room;
                    })();

                    return Ambient;
                })();

                message.Gateway = (function() {

                    /**
                     * Properties of a Gateway.
                     * @memberof cn.beepower.domain.message
                     * @interface IGateway
                     * @property {string|null} [id] Gateway id
                     * @property {cn.beepower.domain.message.IAmbient|null} [ambient] Gateway ambient
                     * @property {Array.<cn.beepower.domain.message.IInstructions>|null} [instructions] Gateway instructions
                     * @property {Array.<cn.beepower.domain.message.IIndex>|null} [indexes] Gateway indexes
                     * @property {Array.<cn.beepower.domain.message.IHolidays>|null} [holidays] Gateway holidays
                     */

                    /**
                     * Constructs a new Gateway.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a Gateway.
                     * @implements IGateway
                     * @constructor
                     * @param {cn.beepower.domain.message.IGateway=} [properties] Properties to set
                     */
                    function Gateway(properties) {
                        this.instructions = [];
                        this.indexes = [];
                        this.holidays = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Gateway id.
                     * @member {string} id
                     * @memberof cn.beepower.domain.message.Gateway
                     * @instance
                     */
                    Gateway.prototype.id = "";

                    /**
                     * Gateway ambient.
                     * @member {cn.beepower.domain.message.IAmbient|null|undefined} ambient
                     * @memberof cn.beepower.domain.message.Gateway
                     * @instance
                     */
                    Gateway.prototype.ambient = null;

                    /**
                     * Gateway instructions.
                     * @member {Array.<cn.beepower.domain.message.IInstructions>} instructions
                     * @memberof cn.beepower.domain.message.Gateway
                     * @instance
                     */
                    Gateway.prototype.instructions = $util.emptyArray;

                    /**
                     * Gateway indexes.
                     * @member {Array.<cn.beepower.domain.message.IIndex>} indexes
                     * @memberof cn.beepower.domain.message.Gateway
                     * @instance
                     */
                    Gateway.prototype.indexes = $util.emptyArray;

                    /**
                     * Gateway holidays.
                     * @member {Array.<cn.beepower.domain.message.IHolidays>} holidays
                     * @memberof cn.beepower.domain.message.Gateway
                     * @instance
                     */
                    Gateway.prototype.holidays = $util.emptyArray;

                    /**
                     * Creates a new Gateway instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Gateway
                     * @static
                     * @param {cn.beepower.domain.message.IGateway=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Gateway} Gateway instance
                     */
                    Gateway.create = function create(properties) {
                        return new Gateway(properties);
                    };

                    /**
                     * Encodes the specified Gateway message. Does not implicitly {@link cn.beepower.domain.message.Gateway.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Gateway
                     * @static
                     * @param {cn.beepower.domain.message.IGateway} message Gateway message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Gateway.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.ambient != null && Object.hasOwnProperty.call(message, "ambient"))
                            $root.cn.beepower.domain.message.Ambient.encode(message.ambient, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.instructions != null && message.instructions.length)
                            for (var i = 0; i < message.instructions.length; ++i)
                                $root.cn.beepower.domain.message.Instructions.encode(message.instructions[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.indexes != null && message.indexes.length)
                            for (var i = 0; i < message.indexes.length; ++i)
                                $root.cn.beepower.domain.message.Index.encode(message.indexes[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.holidays != null && message.holidays.length)
                            for (var i = 0; i < message.holidays.length; ++i)
                                $root.cn.beepower.domain.message.Holidays.encode(message.holidays[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified Gateway message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Gateway.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Gateway
                     * @static
                     * @param {cn.beepower.domain.message.IGateway} message Gateway message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Gateway.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Gateway message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Gateway
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Gateway} Gateway
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Gateway.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Gateway();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.string();
                                break;
                            case 5:
                                message.ambient = $root.cn.beepower.domain.message.Ambient.decode(reader, reader.uint32());
                                break;
                            case 6:
                                if (!(message.instructions && message.instructions.length))
                                    message.instructions = [];
                                message.instructions.push($root.cn.beepower.domain.message.Instructions.decode(reader, reader.uint32()));
                                break;
                            case 7:
                                if (!(message.indexes && message.indexes.length))
                                    message.indexes = [];
                                message.indexes.push($root.cn.beepower.domain.message.Index.decode(reader, reader.uint32()));
                                break;
                            case 8:
                                if (!(message.holidays && message.holidays.length))
                                    message.holidays = [];
                                message.holidays.push($root.cn.beepower.domain.message.Holidays.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Gateway message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Gateway
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Gateway} Gateway
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Gateway.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Gateway message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Gateway
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Gateway.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.ambient != null && message.hasOwnProperty("ambient")) {
                            var error = $root.cn.beepower.domain.message.Ambient.verify(message.ambient);
                            if (error)
                                return "ambient." + error;
                        }
                        if (message.instructions != null && message.hasOwnProperty("instructions")) {
                            if (!Array.isArray(message.instructions))
                                return "instructions: array expected";
                            for (var i = 0; i < message.instructions.length; ++i) {
                                var error = $root.cn.beepower.domain.message.Instructions.verify(message.instructions[i]);
                                if (error)
                                    return "instructions." + error;
                            }
                        }
                        if (message.indexes != null && message.hasOwnProperty("indexes")) {
                            if (!Array.isArray(message.indexes))
                                return "indexes: array expected";
                            for (var i = 0; i < message.indexes.length; ++i) {
                                var error = $root.cn.beepower.domain.message.Index.verify(message.indexes[i]);
                                if (error)
                                    return "indexes." + error;
                            }
                        }
                        if (message.holidays != null && message.hasOwnProperty("holidays")) {
                            if (!Array.isArray(message.holidays))
                                return "holidays: array expected";
                            for (var i = 0; i < message.holidays.length; ++i) {
                                var error = $root.cn.beepower.domain.message.Holidays.verify(message.holidays[i]);
                                if (error)
                                    return "holidays." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a Gateway message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Gateway
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Gateway} Gateway
                     */
                    Gateway.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Gateway)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Gateway();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.ambient != null) {
                            if (typeof object.ambient !== "object")
                                throw TypeError(".cn.beepower.domain.message.Gateway.ambient: object expected");
                            message.ambient = $root.cn.beepower.domain.message.Ambient.fromObject(object.ambient);
                        }
                        if (object.instructions) {
                            if (!Array.isArray(object.instructions))
                                throw TypeError(".cn.beepower.domain.message.Gateway.instructions: array expected");
                            message.instructions = [];
                            for (var i = 0; i < object.instructions.length; ++i) {
                                if (typeof object.instructions[i] !== "object")
                                    throw TypeError(".cn.beepower.domain.message.Gateway.instructions: object expected");
                                message.instructions[i] = $root.cn.beepower.domain.message.Instructions.fromObject(object.instructions[i]);
                            }
                        }
                        if (object.indexes) {
                            if (!Array.isArray(object.indexes))
                                throw TypeError(".cn.beepower.domain.message.Gateway.indexes: array expected");
                            message.indexes = [];
                            for (var i = 0; i < object.indexes.length; ++i) {
                                if (typeof object.indexes[i] !== "object")
                                    throw TypeError(".cn.beepower.domain.message.Gateway.indexes: object expected");
                                message.indexes[i] = $root.cn.beepower.domain.message.Index.fromObject(object.indexes[i]);
                            }
                        }
                        if (object.holidays) {
                            if (!Array.isArray(object.holidays))
                                throw TypeError(".cn.beepower.domain.message.Gateway.holidays: array expected");
                            message.holidays = [];
                            for (var i = 0; i < object.holidays.length; ++i) {
                                if (typeof object.holidays[i] !== "object")
                                    throw TypeError(".cn.beepower.domain.message.Gateway.holidays: object expected");
                                message.holidays[i] = $root.cn.beepower.domain.message.Holidays.fromObject(object.holidays[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a Gateway message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Gateway
                     * @static
                     * @param {cn.beepower.domain.message.Gateway} message Gateway
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Gateway.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.instructions = [];
                            object.indexes = [];
                            object.holidays = [];
                        }
                        if (options.defaults) {
                            object.id = "";
                            object.ambient = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.ambient != null && message.hasOwnProperty("ambient"))
                            object.ambient = $root.cn.beepower.domain.message.Ambient.toObject(message.ambient, options);
                        if (message.instructions && message.instructions.length) {
                            object.instructions = [];
                            for (var j = 0; j < message.instructions.length; ++j)
                                object.instructions[j] = $root.cn.beepower.domain.message.Instructions.toObject(message.instructions[j], options);
                        }
                        if (message.indexes && message.indexes.length) {
                            object.indexes = [];
                            for (var j = 0; j < message.indexes.length; ++j)
                                object.indexes[j] = $root.cn.beepower.domain.message.Index.toObject(message.indexes[j], options);
                        }
                        if (message.holidays && message.holidays.length) {
                            object.holidays = [];
                            for (var j = 0; j < message.holidays.length; ++j)
                                object.holidays[j] = $root.cn.beepower.domain.message.Holidays.toObject(message.holidays[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this Gateway to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Gateway
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Gateway.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Gateway;
                })();

                message.KCurve = (function() {

                    /**
                     * Properties of a KCurve.
                     * @memberof cn.beepower.domain.message
                     * @interface IKCurve
                     * @property {number|null} [upper] KCurve upper
                     * @property {number|null} [lower] KCurve lower
                     * @property {number|null} [begin] KCurve begin
                     * @property {number|null} [end] KCurve end
                     * @property {number|null} [volume] KCurve volume
                     * @property {number|Long|null} [tUpper] KCurve tUpper
                     * @property {number|Long|null} [tLower] KCurve tLower
                     * @property {Array.<cn.beepower.domain.message.KCurve.IPoint>|null} [points] KCurve points
                     */

                    /**
                     * Constructs a new KCurve.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a KCurve.
                     * @implements IKCurve
                     * @constructor
                     * @param {cn.beepower.domain.message.IKCurve=} [properties] Properties to set
                     */
                    function KCurve(properties) {
                        this.points = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * KCurve upper.
                     * @member {number} upper
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     */
                    KCurve.prototype.upper = 0;

                    /**
                     * KCurve lower.
                     * @member {number} lower
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     */
                    KCurve.prototype.lower = 0;

                    /**
                     * KCurve begin.
                     * @member {number} begin
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     */
                    KCurve.prototype.begin = 0;

                    /**
                     * KCurve end.
                     * @member {number} end
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     */
                    KCurve.prototype.end = 0;

                    /**
                     * KCurve volume.
                     * @member {number} volume
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     */
                    KCurve.prototype.volume = 0;

                    /**
                     * KCurve tUpper.
                     * @member {number|Long} tUpper
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     */
                    KCurve.prototype.tUpper = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * KCurve tLower.
                     * @member {number|Long} tLower
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     */
                    KCurve.prototype.tLower = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * KCurve points.
                     * @member {Array.<cn.beepower.domain.message.KCurve.IPoint>} points
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     */
                    KCurve.prototype.points = $util.emptyArray;

                    /**
                     * Creates a new KCurve instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.KCurve
                     * @static
                     * @param {cn.beepower.domain.message.IKCurve=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.KCurve} KCurve instance
                     */
                    KCurve.create = function create(properties) {
                        return new KCurve(properties);
                    };

                    /**
                     * Encodes the specified KCurve message. Does not implicitly {@link cn.beepower.domain.message.KCurve.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.KCurve
                     * @static
                     * @param {cn.beepower.domain.message.IKCurve} message KCurve message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    KCurve.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.upper != null && Object.hasOwnProperty.call(message, "upper"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.upper);
                        if (message.lower != null && Object.hasOwnProperty.call(message, "lower"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.lower);
                        if (message.begin != null && Object.hasOwnProperty.call(message, "begin"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.begin);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.end);
                        if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.volume);
                        if (message.tUpper != null && Object.hasOwnProperty.call(message, "tUpper"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.tUpper);
                        if (message.tLower != null && Object.hasOwnProperty.call(message, "tLower"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.tLower);
                        if (message.points != null && message.points.length)
                            for (var i = 0; i < message.points.length; ++i)
                                $root.cn.beepower.domain.message.KCurve.Point.encode(message.points[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified KCurve message, length delimited. Does not implicitly {@link cn.beepower.domain.message.KCurve.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.KCurve
                     * @static
                     * @param {cn.beepower.domain.message.IKCurve} message KCurve message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    KCurve.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a KCurve message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.KCurve
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.KCurve} KCurve
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    KCurve.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.KCurve();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.upper = reader.float();
                                break;
                            case 2:
                                message.lower = reader.float();
                                break;
                            case 3:
                                message.begin = reader.float();
                                break;
                            case 4:
                                message.end = reader.float();
                                break;
                            case 5:
                                message.volume = reader.float();
                                break;
                            case 10:
                                message.tUpper = reader.int64();
                                break;
                            case 11:
                                message.tLower = reader.int64();
                                break;
                            case 12:
                                if (!(message.points && message.points.length))
                                    message.points = [];
                                message.points.push($root.cn.beepower.domain.message.KCurve.Point.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a KCurve message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.KCurve
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.KCurve} KCurve
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    KCurve.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a KCurve message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.KCurve
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    KCurve.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.upper != null && message.hasOwnProperty("upper"))
                            if (typeof message.upper !== "number")
                                return "upper: number expected";
                        if (message.lower != null && message.hasOwnProperty("lower"))
                            if (typeof message.lower !== "number")
                                return "lower: number expected";
                        if (message.begin != null && message.hasOwnProperty("begin"))
                            if (typeof message.begin !== "number")
                                return "begin: number expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (typeof message.end !== "number")
                                return "end: number expected";
                        if (message.volume != null && message.hasOwnProperty("volume"))
                            if (typeof message.volume !== "number")
                                return "volume: number expected";
                        if (message.tUpper != null && message.hasOwnProperty("tUpper"))
                            if (!$util.isInteger(message.tUpper) && !(message.tUpper && $util.isInteger(message.tUpper.low) && $util.isInteger(message.tUpper.high)))
                                return "tUpper: integer|Long expected";
                        if (message.tLower != null && message.hasOwnProperty("tLower"))
                            if (!$util.isInteger(message.tLower) && !(message.tLower && $util.isInteger(message.tLower.low) && $util.isInteger(message.tLower.high)))
                                return "tLower: integer|Long expected";
                        if (message.points != null && message.hasOwnProperty("points")) {
                            if (!Array.isArray(message.points))
                                return "points: array expected";
                            for (var i = 0; i < message.points.length; ++i) {
                                var error = $root.cn.beepower.domain.message.KCurve.Point.verify(message.points[i]);
                                if (error)
                                    return "points." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a KCurve message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.KCurve
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.KCurve} KCurve
                     */
                    KCurve.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.KCurve)
                            return object;
                        var message = new $root.cn.beepower.domain.message.KCurve();
                        if (object.upper != null)
                            message.upper = Number(object.upper);
                        if (object.lower != null)
                            message.lower = Number(object.lower);
                        if (object.begin != null)
                            message.begin = Number(object.begin);
                        if (object.end != null)
                            message.end = Number(object.end);
                        if (object.volume != null)
                            message.volume = Number(object.volume);
                        if (object.tUpper != null)
                            if ($util.Long)
                                (message.tUpper = $util.Long.fromValue(object.tUpper)).unsigned = false;
                            else if (typeof object.tUpper === "string")
                                message.tUpper = parseInt(object.tUpper, 10);
                            else if (typeof object.tUpper === "number")
                                message.tUpper = object.tUpper;
                            else if (typeof object.tUpper === "object")
                                message.tUpper = new $util.LongBits(object.tUpper.low >>> 0, object.tUpper.high >>> 0).toNumber();
                        if (object.tLower != null)
                            if ($util.Long)
                                (message.tLower = $util.Long.fromValue(object.tLower)).unsigned = false;
                            else if (typeof object.tLower === "string")
                                message.tLower = parseInt(object.tLower, 10);
                            else if (typeof object.tLower === "number")
                                message.tLower = object.tLower;
                            else if (typeof object.tLower === "object")
                                message.tLower = new $util.LongBits(object.tLower.low >>> 0, object.tLower.high >>> 0).toNumber();
                        if (object.points) {
                            if (!Array.isArray(object.points))
                                throw TypeError(".cn.beepower.domain.message.KCurve.points: array expected");
                            message.points = [];
                            for (var i = 0; i < object.points.length; ++i) {
                                if (typeof object.points[i] !== "object")
                                    throw TypeError(".cn.beepower.domain.message.KCurve.points: object expected");
                                message.points[i] = $root.cn.beepower.domain.message.KCurve.Point.fromObject(object.points[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a KCurve message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.KCurve
                     * @static
                     * @param {cn.beepower.domain.message.KCurve} message KCurve
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    KCurve.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.points = [];
                        if (options.defaults) {
                            object.upper = 0;
                            object.lower = 0;
                            object.begin = 0;
                            object.end = 0;
                            object.volume = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.tUpper = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.tUpper = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.tLower = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.tLower = options.longs === String ? "0" : 0;
                        }
                        if (message.upper != null && message.hasOwnProperty("upper"))
                            object.upper = options.json && !isFinite(message.upper) ? String(message.upper) : message.upper;
                        if (message.lower != null && message.hasOwnProperty("lower"))
                            object.lower = options.json && !isFinite(message.lower) ? String(message.lower) : message.lower;
                        if (message.begin != null && message.hasOwnProperty("begin"))
                            object.begin = options.json && !isFinite(message.begin) ? String(message.begin) : message.begin;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = options.json && !isFinite(message.end) ? String(message.end) : message.end;
                        if (message.volume != null && message.hasOwnProperty("volume"))
                            object.volume = options.json && !isFinite(message.volume) ? String(message.volume) : message.volume;
                        if (message.tUpper != null && message.hasOwnProperty("tUpper"))
                            if (typeof message.tUpper === "number")
                                object.tUpper = options.longs === String ? String(message.tUpper) : message.tUpper;
                            else
                                object.tUpper = options.longs === String ? $util.Long.prototype.toString.call(message.tUpper) : options.longs === Number ? new $util.LongBits(message.tUpper.low >>> 0, message.tUpper.high >>> 0).toNumber() : message.tUpper;
                        if (message.tLower != null && message.hasOwnProperty("tLower"))
                            if (typeof message.tLower === "number")
                                object.tLower = options.longs === String ? String(message.tLower) : message.tLower;
                            else
                                object.tLower = options.longs === String ? $util.Long.prototype.toString.call(message.tLower) : options.longs === Number ? new $util.LongBits(message.tLower.low >>> 0, message.tLower.high >>> 0).toNumber() : message.tLower;
                        if (message.points && message.points.length) {
                            object.points = [];
                            for (var j = 0; j < message.points.length; ++j)
                                object.points[j] = $root.cn.beepower.domain.message.KCurve.Point.toObject(message.points[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this KCurve to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.KCurve
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    KCurve.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    KCurve.Point = (function() {

                        /**
                         * Properties of a Point.
                         * @memberof cn.beepower.domain.message.KCurve
                         * @interface IPoint
                         * @property {number|Long|null} [t] Point t
                         * @property {number|null} [v] Point v
                         */

                        /**
                         * Constructs a new Point.
                         * @memberof cn.beepower.domain.message.KCurve
                         * @classdesc Represents a Point.
                         * @implements IPoint
                         * @constructor
                         * @param {cn.beepower.domain.message.KCurve.IPoint=} [properties] Properties to set
                         */
                        function Point(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Point t.
                         * @member {number|Long} t
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @instance
                         */
                        Point.prototype.t = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Point v.
                         * @member {number} v
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @instance
                         */
                        Point.prototype.v = 0;

                        /**
                         * Creates a new Point instance using the specified properties.
                         * @function create
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @static
                         * @param {cn.beepower.domain.message.KCurve.IPoint=} [properties] Properties to set
                         * @returns {cn.beepower.domain.message.KCurve.Point} Point instance
                         */
                        Point.create = function create(properties) {
                            return new Point(properties);
                        };

                        /**
                         * Encodes the specified Point message. Does not implicitly {@link cn.beepower.domain.message.KCurve.Point.verify|verify} messages.
                         * @function encode
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @static
                         * @param {cn.beepower.domain.message.KCurve.IPoint} message Point message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Point.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.t != null && Object.hasOwnProperty.call(message, "t"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.t);
                            if (message.v != null && Object.hasOwnProperty.call(message, "v"))
                                writer.uint32(/* id 2, wireType 5 =*/21).float(message.v);
                            return writer;
                        };

                        /**
                         * Encodes the specified Point message, length delimited. Does not implicitly {@link cn.beepower.domain.message.KCurve.Point.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @static
                         * @param {cn.beepower.domain.message.KCurve.IPoint} message Point message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Point.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Point message from the specified reader or buffer.
                         * @function decode
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {cn.beepower.domain.message.KCurve.Point} Point
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Point.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.KCurve.Point();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.t = reader.int64();
                                    break;
                                case 2:
                                    message.v = reader.float();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Point message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {cn.beepower.domain.message.KCurve.Point} Point
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Point.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Point message.
                         * @function verify
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Point.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.t != null && message.hasOwnProperty("t"))
                                if (!$util.isInteger(message.t) && !(message.t && $util.isInteger(message.t.low) && $util.isInteger(message.t.high)))
                                    return "t: integer|Long expected";
                            if (message.v != null && message.hasOwnProperty("v"))
                                if (typeof message.v !== "number")
                                    return "v: number expected";
                            return null;
                        };

                        /**
                         * Creates a Point message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {cn.beepower.domain.message.KCurve.Point} Point
                         */
                        Point.fromObject = function fromObject(object) {
                            if (object instanceof $root.cn.beepower.domain.message.KCurve.Point)
                                return object;
                            var message = new $root.cn.beepower.domain.message.KCurve.Point();
                            if (object.t != null)
                                if ($util.Long)
                                    (message.t = $util.Long.fromValue(object.t)).unsigned = false;
                                else if (typeof object.t === "string")
                                    message.t = parseInt(object.t, 10);
                                else if (typeof object.t === "number")
                                    message.t = object.t;
                                else if (typeof object.t === "object")
                                    message.t = new $util.LongBits(object.t.low >>> 0, object.t.high >>> 0).toNumber();
                            if (object.v != null)
                                message.v = Number(object.v);
                            return message;
                        };

                        /**
                         * Creates a plain object from a Point message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @static
                         * @param {cn.beepower.domain.message.KCurve.Point} message Point
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Point.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.t = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.t = options.longs === String ? "0" : 0;
                                object.v = 0;
                            }
                            if (message.t != null && message.hasOwnProperty("t"))
                                if (typeof message.t === "number")
                                    object.t = options.longs === String ? String(message.t) : message.t;
                                else
                                    object.t = options.longs === String ? $util.Long.prototype.toString.call(message.t) : options.longs === Number ? new $util.LongBits(message.t.low >>> 0, message.t.high >>> 0).toNumber() : message.t;
                            if (message.v != null && message.hasOwnProperty("v"))
                                object.v = options.json && !isFinite(message.v) ? String(message.v) : message.v;
                            return object;
                        };

                        /**
                         * Converts this Point to JSON.
                         * @function toJSON
                         * @memberof cn.beepower.domain.message.KCurve.Point
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Point.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        return Point;
                    })();

                    return KCurve;
                })();

                message.Revision = (function() {

                    /**
                     * Properties of a Revision.
                     * @memberof cn.beepower.domain.message
                     * @interface IRevision
                     * @property {string|null} [tId] Revision tId
                     * @property {string|null} [key] Revision key
                     * @property {number|Long|null} [t] Revision t
                     * @property {cn.beepower.domain.message.IItem|null} [v] Revision v
                     */

                    /**
                     * Constructs a new Revision.
                     * @memberof cn.beepower.domain.message
                     * @classdesc Represents a Revision.
                     * @implements IRevision
                     * @constructor
                     * @param {cn.beepower.domain.message.IRevision=} [properties] Properties to set
                     */
                    function Revision(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Revision tId.
                     * @member {string} tId
                     * @memberof cn.beepower.domain.message.Revision
                     * @instance
                     */
                    Revision.prototype.tId = "";

                    /**
                     * Revision key.
                     * @member {string} key
                     * @memberof cn.beepower.domain.message.Revision
                     * @instance
                     */
                    Revision.prototype.key = "";

                    /**
                     * Revision t.
                     * @member {number|Long} t
                     * @memberof cn.beepower.domain.message.Revision
                     * @instance
                     */
                    Revision.prototype.t = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Revision v.
                     * @member {cn.beepower.domain.message.IItem|null|undefined} v
                     * @memberof cn.beepower.domain.message.Revision
                     * @instance
                     */
                    Revision.prototype.v = null;

                    /**
                     * Creates a new Revision instance using the specified properties.
                     * @function create
                     * @memberof cn.beepower.domain.message.Revision
                     * @static
                     * @param {cn.beepower.domain.message.IRevision=} [properties] Properties to set
                     * @returns {cn.beepower.domain.message.Revision} Revision instance
                     */
                    Revision.create = function create(properties) {
                        return new Revision(properties);
                    };

                    /**
                     * Encodes the specified Revision message. Does not implicitly {@link cn.beepower.domain.message.Revision.verify|verify} messages.
                     * @function encode
                     * @memberof cn.beepower.domain.message.Revision
                     * @static
                     * @param {cn.beepower.domain.message.IRevision} message Revision message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Revision.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tId != null && Object.hasOwnProperty.call(message, "tId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.tId);
                        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
                        if (message.t != null && Object.hasOwnProperty.call(message, "t"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.t);
                        if (message.v != null && Object.hasOwnProperty.call(message, "v"))
                            $root.cn.beepower.domain.message.Item.encode(message.v, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified Revision message, length delimited. Does not implicitly {@link cn.beepower.domain.message.Revision.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof cn.beepower.domain.message.Revision
                     * @static
                     * @param {cn.beepower.domain.message.IRevision} message Revision message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Revision.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Revision message from the specified reader or buffer.
                     * @function decode
                     * @memberof cn.beepower.domain.message.Revision
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {cn.beepower.domain.message.Revision} Revision
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Revision.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.cn.beepower.domain.message.Revision();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.tId = reader.string();
                                break;
                            case 2:
                                message.key = reader.string();
                                break;
                            case 3:
                                message.t = reader.int64();
                                break;
                            case 4:
                                message.v = $root.cn.beepower.domain.message.Item.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Revision message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof cn.beepower.domain.message.Revision
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {cn.beepower.domain.message.Revision} Revision
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Revision.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Revision message.
                     * @function verify
                     * @memberof cn.beepower.domain.message.Revision
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Revision.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tId != null && message.hasOwnProperty("tId"))
                            if (!$util.isString(message.tId))
                                return "tId: string expected";
                        if (message.key != null && message.hasOwnProperty("key"))
                            if (!$util.isString(message.key))
                                return "key: string expected";
                        if (message.t != null && message.hasOwnProperty("t"))
                            if (!$util.isInteger(message.t) && !(message.t && $util.isInteger(message.t.low) && $util.isInteger(message.t.high)))
                                return "t: integer|Long expected";
                        if (message.v != null && message.hasOwnProperty("v")) {
                            var error = $root.cn.beepower.domain.message.Item.verify(message.v);
                            if (error)
                                return "v." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a Revision message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof cn.beepower.domain.message.Revision
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {cn.beepower.domain.message.Revision} Revision
                     */
                    Revision.fromObject = function fromObject(object) {
                        if (object instanceof $root.cn.beepower.domain.message.Revision)
                            return object;
                        var message = new $root.cn.beepower.domain.message.Revision();
                        if (object.tId != null)
                            message.tId = String(object.tId);
                        if (object.key != null)
                            message.key = String(object.key);
                        if (object.t != null)
                            if ($util.Long)
                                (message.t = $util.Long.fromValue(object.t)).unsigned = false;
                            else if (typeof object.t === "string")
                                message.t = parseInt(object.t, 10);
                            else if (typeof object.t === "number")
                                message.t = object.t;
                            else if (typeof object.t === "object")
                                message.t = new $util.LongBits(object.t.low >>> 0, object.t.high >>> 0).toNumber();
                        if (object.v != null) {
                            if (typeof object.v !== "object")
                                throw TypeError(".cn.beepower.domain.message.Revision.v: object expected");
                            message.v = $root.cn.beepower.domain.message.Item.fromObject(object.v);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a Revision message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof cn.beepower.domain.message.Revision
                     * @static
                     * @param {cn.beepower.domain.message.Revision} message Revision
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Revision.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.tId = "";
                            object.key = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.t = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.t = options.longs === String ? "0" : 0;
                            object.v = null;
                        }
                        if (message.tId != null && message.hasOwnProperty("tId"))
                            object.tId = message.tId;
                        if (message.key != null && message.hasOwnProperty("key"))
                            object.key = message.key;
                        if (message.t != null && message.hasOwnProperty("t"))
                            if (typeof message.t === "number")
                                object.t = options.longs === String ? String(message.t) : message.t;
                            else
                                object.t = options.longs === String ? $util.Long.prototype.toString.call(message.t) : options.longs === Number ? new $util.LongBits(message.t.low >>> 0, message.t.high >>> 0).toNumber() : message.t;
                        if (message.v != null && message.hasOwnProperty("v"))
                            object.v = $root.cn.beepower.domain.message.Item.toObject(message.v, options);
                        return object;
                    };

                    /**
                     * Converts this Revision to JSON.
                     * @function toJSON
                     * @memberof cn.beepower.domain.message.Revision
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Revision.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Revision;
                })();

                return message;
            })();

            return domain;
        })();

        return beepower;
    })();

    return cn;
})();

module.exports = $root;
